export const translations = {
  en: {
    common: {
      searchPlaceholder: 'Search products...',
      search: 'Search',
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      profile: 'Profile',
      myOrders: 'My Orders',
      myReviews: 'My Reviews',
      wishlist: 'Wishlist',
      cart: 'Cart',
      help: 'Help',
      trackOrder: 'Track Order',
      adminDashboard: 'Admin Dashboard',
      categories: 'Categories',
      freeShipping: 'Free shipping on orders over',
      todaysDeals: "Today's Deals",
      newArrivals: 'New Arrivals'
    },
    categories: {
      Electronics: 'Electronics',
      Clothing: 'Clothing',
      Books: 'Books',
      'Home & Garden': 'Home & Garden',
      Sports: 'Sports',
      Beauty: 'Beauty',
      Health: 'Health',
      Toys: 'Toys',
      Automotive: 'Automotive'
    },
    home: {
      welcomeTitle: 'Welcome to ShopHub',
      welcomeSubtitle: 'Your one-stop destination for all your shopping needs. Discover millions of products at unbeatable prices.',
      shopNow: 'Shop Now',
      shopCategory: 'Shop by Category',
      exploreCategories: "Explore our wide range of categories to find exactly what you're looking for.",
      featuredProducts: 'Featured Products',
      discoverFeatured: 'Discover our selection of trending products.',
      viewAllProducts: 'View All Products',
      stayUpdated: 'Stay Updated',
      subscribeText: 'Subscribe to our newsletter for exclusive offers and updates.',
      enterEmail: 'Enter your email',
      subscribe: 'Subscribe',
      subscribing: 'Subscribing...',
      features: {
        freeShipping: 'Free Shipping',
        securePayment: 'Secure Payment',
        securePaymentDesc: '100% secure payment processing',
        moneyBack: 'Money Back',
        moneyBackDesc: '30-day money-back guarantee',
        support: '24/7 Support',
        supportDesc: 'Customer support 24h/24'
      }
    },
    product: {
      availability: 'Availability',
      inStock: 'In Stock',
      outOfStock: 'Out of Stock',
      onlyLeft: 'Only {{count}} left in stock',
      addToCart: 'Add to Cart',
      buyNow: 'Buy Now',
      deliveryOptions: 'Delivery Options',
      standardDelivery: 'Standard Delivery',
      codAvailable: 'Cash on Delivery Available',
      returnWarranty: 'Return & Warranty',
      easyReturn: 'days easy return',
      warranty: 'warranty',
      warrantyNotAvailable: 'Warranty not available',
      description: 'Product Description',
      specifications: 'Specifications',
      whatsInBox: 'What\'s in the Box',
      reviews: 'Reviews',
      questions: 'Q & A',
      writeReview: 'Write a Review',
      writeYourReview: 'Write your Review',
      rating: 'Rating',
      review: 'Review',
      addPhotos: 'Add Photos',
      chooseFiles: 'Choose Files',
      submitReview: 'Submit Review',
      cancel: 'Cancel',
      askQuestion: 'Ask a Question',
      submitQuestion: 'Submit Question',
      askPlaceholder: 'Ask your question about this product...',
      noReviews: 'No reviews yet. Be the first to review this product!',
      noSpecs: 'No specifications available for this product.',
      noBoxContent: 'No box contents information available.',
      answerQ: 'Answer this question',
      submitAnswer: 'Submit Answer'
    },
    cart: {
      title: 'Shopping Cart',
      emptyTitle: 'Your cart is empty',
      emptySubtitle: "Looks like you haven't added any items to your cart yet.",
      continueShopping: 'Continue Shopping',
      clearCart: 'Clear Cart',
      item: 'item',
      items: 'items',
      inStock: 'In Stock',
      outOfStock: 'Out of Stock',
      available: 'available',
      remove: 'Remove',
      orderSummary: 'Order Summary',
      subtotal: 'Subtotal',
      deliveryFee: 'Delivery Fee',
      free: 'FREE',
      addMoreForFree: 'Add {{amount}} more for FREE delivery!',
      total: 'Total',
      proceedToCheckout: 'Proceed to Checkout',
      secureCheckout: 'Secure checkout',
      weAccept: 'We Accept',
      cod: 'Cash on Delivery',
      card: 'Card Payment'
    },
    auth: {
      loginTitle: 'Login to your account',
      registerTitle: 'Create an account',
      email: 'Email Address',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      name: 'Full Name',
      forgotPassword: 'Forgot Password?',
      signIn: 'Sign In',
      signUp: 'Sign Up',
      newCustomer: 'New customer?',
      registerHere: 'Register here',
      alreadyAccount: 'Already have an account?',
      loginHere: 'Login here',
      orContinue: 'Or continue with',
      phone: 'Phone Number',
      loginSuccess: 'Login successful!',
      registerSuccess: 'Registration successful!',
      rememberMe: 'Remember me',
      google: 'Google',
      facebook: 'Facebook'
    },
    support: {
      myTickets: 'My Tickets',
      newTicket: 'New Ticket',
      noTickets: 'No tickets found',
      noTicketsDesc: 'You haven\'t submitted any support tickets yet.',
      createFirst: 'Create your first ticket',
      backToTickets: 'Back to Tickets',
      closeTicket: 'Close Ticket',
      yourMessage: 'Your Message',
      adminResponse: 'Admin Response',
      markedResolved: 'This ticket has been marked as resolved.',
      ticketClosed: 'Ticket Closed',
      closeConfirm: 'Are you sure you want to close this ticket?',
      closeSuccess: 'Ticket closed successfully',
      closeError: 'Failed to close ticket',
      fetchError: 'Failed to load tickets',
      
      // Tracking Page
      trackTitle: 'Track Your Support Request',
      trackSubtitle: 'Enter your Ticket ID and Email to view the status of your request.',
      ticketIdLabel: 'Ticket ID',
      emailLabel: 'Email Address',
      trackButton: 'Track Ticket',
      trackSuccess: 'Ticket found',
      trackError: 'Ticket not found or email does not match',
      trackErrorInput: 'Please enter both Ticket ID and Email',
      trackAnother: 'Track Another Ticket',
      date: 'Date Submitted'
    },
    footer: {
      description: 'Your one-stop destination for all your shopping needs. Quality products at affordable prices.',
      quickLinks: 'Quick Links',
      customerService: 'Customer Service',
      newsletter: 'Newsletter',
      subscribeText: 'Subscribe to get special offers, free giveaways, and updates.',
      about: 'About Us',
      contact: 'Contact',
      careers: 'Careers',
      blog: 'Blog',
      press: 'Press',
      help: 'Help Center',
      track: 'Track Your Order',
      returns: 'Returns & Refunds',
      shipping: 'Shipping Info',
      sizeGuide: 'Size Guide',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      cookies: 'Cookie Policy',
      rights: 'All rights reserved.'
    },
    about: {
      hero: {
        title: 'Welcome to ShopHub',
        subtitle: 'Your premier destination for quality products and exceptional shopping experiences. Discover, shop, and enjoy with confidence.',
        ctaStart: 'Start Shopping',
        ctaLearn: 'Learn More'
      },
      stats: {
        customers: 'Happy Customers',
        products: 'Products Available',
        uptime: 'Uptime Guarantee',
        support: 'Customer Support'
      },
      mission: {
        title: 'Our Mission',
        description: 'At ShopHub, our mission is to revolutionize online shopping by providing a seamless, secure, and enjoyable experience for every customer. We believe that shopping should be convenient, affordable, and accessible to everyone, everywhere.'
      },
      features: {
        title: 'Why Choose ShopHub?',
        subtitle: "We're committed to providing you with the best online shopping experience possible.",
        wideSelection: { title: 'Wide Product Selection', desc: 'Thousands of products across multiple categories to meet all your needs' },
        fastShipping: { title: 'Fast Shipping', desc: 'Quick and reliable delivery right to your doorstep' },
        support247: { title: '24/7 Support', desc: 'Round-the-clock customer service to assist you anytime' },
        securePayment: { title: 'Secure Payments', desc: 'Safe and encrypted payment processing for your peace of mind' },
        qualityGuarantee: { title: 'Quality Guarantee', desc: 'Every product is carefully selected to meet our high standards' },
        trustedPlatform: { title: 'Trusted Platform', desc: 'Built on trust, reliability, and customer satisfaction' }
      },
      values: {
        title: 'Our Core Values',
        subtitle: 'These values guide everything we do and shape our commitment to excellence.',
        quality: { title: 'Quality First', desc: 'We carefully curate our products to ensure they meet the highest quality standards.' },
        trust: { title: 'Customer Trust', desc: 'Building long-term relationships with our customers based on trust and reliability.' },
        innovation: { title: 'Innovation', desc: 'Constantly improving our platform to provide the best shopping experience.' }
      },
      contact: {
        title: 'Get in Touch',
        subtitle: "Have questions or need assistance? Our friendly customer service team is here to help. We're available 24/7 to ensure you have the best shopping experience.",
        call: 'Call Us',
        email: 'Email Us',
        chat: 'Live Chat',
        chatAvail: 'Available 24/7',
        cta: 'Contact Support'
      }
    },
    contactPage: {
      hero: {
        title: 'Get in Touch',
        subtitle: "We're here to help! Send us a message and we'll respond as soon as possible."
      },
      info: {
        title: 'Contact Information',
        address: 'Address',
        phone: 'Phone',
        email: 'Email',
        hours: 'Business Hours',
        days: {
          monFri: 'Mon - Fri',
          satSun: 'Sat - Sun'
        }
      },
      responseTimes: {
        title: 'Response Times',
        general: 'General Inquiries',
        support: 'Support Issues',
        order: 'Order Issues',
        urgent: 'Urgent Matters'
      },
      form: {
        title: 'Send Us a Message',
        name: 'Name',
        namePlaceholder: 'Your full name',
        email: 'Email',
        emailPlaceholder: 'your.email@example.com',
        phone: 'Phone',
        phonePlaceholder: 'Your phone number',
        subject: 'Subject',
        subjects: {
          general: 'General Inquiry',
          support: 'Customer Support',
          order: 'Order Issue',
          return: 'Return/Refund',
          feedback: 'Feedback',
          other: 'Other'
        },
        orderNumber: 'Order Number',
        orderPlaceholder: 'Enter your order ID for faster support',
        orderHint: 'Including your order number helps us assist you faster',
        message: 'Message',
        messagePlaceholder: 'Please describe your inquiry in detail. The more information you provide, the better we can assist you.',
        send: 'Send Message',
        sending: 'Sending Message...'
      },
      success: {
        title: 'Message Sent Successfully!',
        message: "Thank you for contacting us. We've received your message and will get back to you soon.",
        ticketId: 'Your ticket ID:',
        saveId: 'Save this ID for reference when following up on your inquiry.',
        sendAnother: 'Send Another Message'
      }
    },
    helpPage: {
      title: 'Help Center',
      subtitle: 'How can we help you?',
      searchPlaceholder: 'Search for help...',
      categories: {
        orders: { title: 'Orders & Shipping', desc: 'Track orders, shipping info, and delivery updates' },
        returns: { title: 'Returns & Refunds', desc: 'Return policy, refund process, and exchanges' },
        account: { title: 'Account & Payment', desc: 'Account settings, payment methods, and billing' }
      },
      faq: {
        title: 'Frequently Asked Questions',
        q1: { q: 'How do I place an order?', a: "To place an order, browse our products, add items to your cart, and proceed to checkout. You'll need to provide shipping information and payment details." },
        q2: { q: 'What payment methods do you accept?', a: 'We accept all major credit cards (Visa, MasterCard, American Express), PayPal, and Apple Pay.' },
        q3: { q: 'How long does shipping take?', a: 'Standard shipping takes 3-5 business days. Express shipping takes 1-2 business days. Free shipping is available on orders over $50.' },
        q4: { q: 'How can I track my order?', a: "Once your order ships, you'll receive a tracking number via email. You can also track your order by logging into your account." },
        q5: { q: 'What is your return policy?', a: 'We offer a 30-day return policy for most items. Items must be unused and in original packaging. Some restrictions apply.' },
        q6: { q: 'How do I contact customer service?', a: 'You can contact us through our contact form, email us at support@shophub.com, or call 1-800-SHOPHUB.' }
      },
      stillNeedHelp: {
        title: 'Still need help?',
        desc: 'Our customer service team is here to help you 24/7',
        cta: 'Contact Support'
      }
    },
    returnsPage: {
      hero: {
        title: 'Hassle-Free Returns',
        subtitle: "We want you to love your purchase! If you're not completely satisfied, return it within 30 days for a full refund or exchange.",
        badges: { thirtyDay: '30-Day Returns', freeShipping: 'Free Return Shipping*', fastRefunds: 'Fast Refunds' }
      },
      tabs: { policy: 'Return Policy', process: 'Return Process', tracking: 'Track Return', faq: 'FAQ' },
      policy: {
        canReturn: 'What You Can Return',
        cannotReturn: 'What You Cannot Return',
        canReturnList: ['Items in original, unused condition', 'Items with original packaging and tags', 'Items returned within 30 days', 'Items with proof of purchase'],
        cannotReturnList: ['Personalized or customized items', 'Digital downloads and software', 'Perishable goods and food items', 'Items damaged by misuse'],
        timeframes: { title: 'Return Timeframes by Category', most: 'Most Items', electronics: 'Electronics', beauty: 'Health & Beauty' }
      },
      process: {
        title: 'Return Process Timeline',
        steps: {
          initiate: { title: 'Initiate Return', desc: 'Start your request online' },
          pack: { title: 'Pack & Ship', desc: 'Pack securely and ship' },
          processing: { title: 'Processing', desc: 'We inspect and process' },
          refund: { title: 'Refund Issued', desc: 'Refund to original method' }
        },
        startReturn: 'Start a Return',
        startDesc: 'Have an order you need to return?',
        viewOrders: 'View My Orders',
        needHelp: 'Need Help?',
        contactSupport: 'Contact Support'
      },
      tracking: {
        title: 'Track Your Return',
        desc: 'Enter your return tracking number to see current status.',
        placeholder: 'Enter tracking number',
        track: 'Track',
        tips: 'Return Tracking Tips',
        tipsList: ['Tracking provided via email', 'Takes 24-48 hours to appear', 'Contact support if lost']
      },
      faq: {
        title: 'Frequently Asked Questions',
        q1: { q: 'How long do I have to return?', a: '30 days from delivery date.' },
        q2: { q: 'Who pays for return shipping?', a: 'Free for defective items.' },
        q3: { q: 'How long for refund?', a: '3-5 business days after receipt.' },
        q4: { q: 'Without original packaging?', a: 'Original packaging preferred.' },
        q5: { q: 'What cannot be returned?', a: 'Personalized, digital, perishable.' },
        q6: { q: 'Can I exchange?', a: 'Yes! Exchanges are processed as new orders.' }
      },
      footer: {
        guarantee: '100% Satisfaction Guarantee',
        desc: 'We stand behind every product we sell.',
        email: 'Email Support',
        phone: 'Phone Support',
        hours: 'Business Hours'
      }
    },
    shippingPage: {
      hero: {
        title: 'Shipping Information',
        subtitle: 'Fast, reliable shipping with multiple options.',
        badges: { free: 'Free Shipping Rs. 1000+', tracking: 'Tracking Included', packaging: 'Secure Packaging' }
      },
      tabs: { domestic: 'Domestic Shipping', international: 'International', calculator: 'Shipping Calculator' },
      domestic: {
        heroTitle: 'Fast & Reliable Shipping',
        options: {
          standard: { name: 'Standard Shipping', time: '5-7 business days' },
          express: { name: 'Express Shipping', time: '2-3 business days' },
          overnight: { name: 'Overnight Express', time: '1 business day' }
        },
        coverage: 'Delivery Coverage Areas',
        majorCities: 'Major Cities',
        otherAreas: 'Other Areas',
        services: 'Special Shipping Services',
        fragile: 'Fragile Item Shipping',
        scheduled: 'Scheduled Delivery'
      },
      international: {
        title: 'International Shipping',
        subtitle: 'We ship worldwide with reliable delivery.',
        zones: { zone1: 'Zone 1 (NA/UK/AUS)', zone2: 'Zone 2 (EU/Asia)', zone3: 'Zone 3 (Others)' },
        info: 'Important International Shipping Information'
      },
      calculator: {
        title: 'Shipping Calculator',
        subtitle: 'Calculate shipping costs for your location.',
        placeholder: 'Enter ZIP code',
        calculate: 'Calculate',
        estimates: 'Quick Estimates'
      },
      faq: {
        title: 'Shipping FAQ',
        q1: { q: 'Free shipping qualification?', a: 'Orders over Rs. 1,000.' },
        q2: { q: 'Weekends/Holidays?', a: 'Processed next business day.' },
        q3: { q: 'Change address?', a: 'Within 1 hour of order.' },
        q4: { q: 'Not home for delivery?', a: '3 attempts then held.' },
        q5: { q: 'PO Boxes?', a: 'Standard shipping only.' },
        q6: { q: 'Accuracy?', a: '95% accurate estimates.' }
      },
      contact: {
        title: 'Need Help with Shipping?',
        subtitle: 'Our team is ready to help.',
        contact: 'Contact Support',
        track: 'Track Your Order'
      }
    },
    sizeGuidePage: {
      title: 'Size Guide',
      subtitle: 'Find your perfect fit with our comprehensive guide.',
      categories: { clothing: 'Clothing', pants: 'Pants & Jeans', shoes: 'Footwear' },
      table: {
        size: 'Size', chest: 'Chest (cm)', waist: 'Waist (cm)', hips: 'Hips (cm)', length: 'Length (cm)',
        shoulder: 'Shoulder (cm)', sleeve: 'Sleeve (cm)', inseam: 'Inseam (cm)', uk: 'UK', us: 'US', eu: 'EU'
      },
      measure: {
        title: 'How to Measure',
        body: 'Body Measurements',
        garment: 'Garment Measurements',
        foot: 'Foot Measurements',
        chest: 'Chest', waist: 'Waist', hips: 'Hips', length: 'Inseam/Length',
        shoulder: 'Shoulder', sleeve: 'Sleeve', ftLength: 'Length', width: 'Width'
      },
      tips: {
        title: 'Sizing Tips',
        list: ['If between sizes, size up.', 'Check brand variations.', 'Ask for help measuring.', 'Tape should be snug.', 'Contact us for help.']
      }
    },
    trackOrderPage: {
      title: 'Track Your Order',
      subtitle: 'Enter your tracking number or order details to get real-time updates',
      search: {
        byTracking: 'By Tracking Number',
        byOrder: 'By Order ID',
        trackingLabel: 'Tracking Number',
        orderLabel: 'Order ID',
        emailLabel: 'Email Address',
        trackingPlaceholder: 'Enter your tracking number (e.g., TRK123456789)',
        orderPlaceholder: 'Enter your order ID (e.g., 507f1f77bcf86cd799439011)',
        emailPlaceholder: 'Enter the email used for this order',
        button: 'Track Order',
        loading: 'Tracking...',
      },
      error: {
        emptyInput: 'Please enter a tracking number or order ID',
        emptyEmail: 'Please enter your email address',
      },
      summary: {
        title: 'Order Summary',
        details: 'Order Details',
        orderId: 'Order ID',
        date: 'Order Date',
        amount: 'Total Amount',
        status: 'Status',
        trackingNumber: 'Tracking Number',
        shippingAddress: 'Shipping Address',
        items: 'Items Ordered',
        quantity: 'Quantity',
      },
      timeline: {
        title: 'Tracking Timeline',
        trackWith: 'Track with',
        estimated: 'Estimated',
        viewOnCarrier: 'View on carrier website',
      },
      help: {
        title: 'Need Help with Your Order?',
        subtitle: 'If you have any questions or concerns about your order, our customer support team is here to help.',
        contact: 'Contact Support',
        center: 'Help Center',
      }
    },
    careersPage: {
      hero: {
        title: 'Join Our Team',
        subtitle: 'Help us build the future of e-commerce. Join a team of passionate individuals creating products that millions of people love.',
        viewPositions: 'View Open Positions',
        learnCulture: 'Learn About Culture'
      },
      stats: {
        members: 'Team Members',
        positions: 'Open Positions',
        countries: 'Countries',
        rating: 'Glassdoor Rating'
      },
      values: {
        title: 'Our Values',
        subtitle: 'These core values guide everything we do and shape our culture.',
        customer: { title: 'Customer Obsession', desc: 'We put our customers at the heart of everything we do, building products that truly solve their problems.' },
        innovation: { title: 'Innovation', desc: 'We embrace new technologies and creative solutions to stay ahead of the curve.' },
        collaboration: { title: 'Collaboration', desc: 'We believe the best work happens when diverse teams collaborate openly and respectfully.' },
        excellence: { title: 'Excellence', desc: 'We set high standards and continuously strive to exceed expectations in all we do.' }
      },
      benefits: {
        title: 'Why Work With Us',
        subtitle: 'We offer competitive benefits and a culture that supports your growth and well-being.',
        health: { title: 'Health & Wellness', desc: 'Comprehensive health, dental, and vision insurance plus wellness programs' },
        schedule: { title: 'Flexible Schedule', desc: 'Work-life balance with flexible hours and unlimited PTO' },
        learning: { title: 'Learning & Growth', desc: '$2,000 annual learning budget and conference attendance' },
        remote: { title: 'Remote-First', desc: 'Work from anywhere with quarterly team gatherings' },
        pay: { title: 'Competitive Pay', desc: 'Top-tier compensation with equity and performance bonuses' },
        innovation: { title: 'Innovation Time', desc: '20% time for personal projects and innovation initiatives' }
      },
      jobs: {
        title: 'Open Positions',
        subtitle: 'Find your next career opportunity and join our growing team.',
        apply: 'Apply Now',
        learnMore: 'Learn More',
        requirements: 'Key Requirements:',
        frontend: { title: 'Senior Frontend Developer', dept: 'Engineering', desc: 'Join our frontend team to build the next generation of e-commerce experiences using React, TypeScript, and modern web technologies.', reqs: ['5+ years React experience', 'TypeScript proficiency', 'E-commerce background preferred'] },
        marketing: { title: 'Product Marketing Manager', dept: 'Marketing', desc: 'Drive product marketing strategy and go-to-market initiatives for our growing e-commerce platform.', reqs: ['3+ years product marketing', 'B2B SaaS experience', 'Data-driven mindset'] },
        design: { title: 'UX/UI Designer', dept: 'Design', desc: 'Create beautiful, intuitive user experiences that delight our millions of users worldwide.', reqs: ['Figma expertise', 'User research experience', 'E-commerce design portfolio'] },
        devops: { title: 'DevOps Engineer', dept: 'Engineering', desc: 'Scale our infrastructure to support millions of transactions and ensure 99.9% uptime.', reqs: ['AWS/Azure experience', 'Kubernetes proficiency', 'CI/CD expertise'] },
        cs: { title: 'Customer Success Manager', dept: 'Customer Success', desc: 'Help our enterprise customers succeed and grow their business using our platform.', reqs: ['2+ years customer success', 'Strong communication skills', 'Problem-solving abilities'] },
        data: { title: 'Data Scientist', dept: 'Analytics', desc: 'Use machine learning and analytics to drive insights and optimize our platform performance.', reqs: ['Python/R proficiency', 'ML/AI experience', 'Statistics background'] }
      },
      testimonials: {
        title: 'What Our Team Says',
        subtitle: 'Hear from our team members about what makes ShopHub a great place to work.',
        sarah: { role: 'Senior Product Manager', quote: "The growth opportunities here are incredible. In just two years, I've led three major product launches and grown my team from 2 to 8 people." },
        marcus: { role: 'Full Stack Developer', quote: "The engineering culture is outstanding. We use cutting-edge tech, have great code review processes, and everyone is always willing to help." },
        emily: { role: 'Design Lead', quote: "I love how user-centered our design process is. We regularly talk to customers and iterate based on real feedback." }
      },
      process: {
        title: 'Ready to Apply?',
        subtitle: "Join us in building the future of e-commerce. We can't wait to meet you!",
        step1: { title: 'Apply Online', desc: "Submit your application and tell us why you're excited to join ShopHub." },
        step2: { title: 'Interview Process', desc: 'Meet with our team through a series of interviews to discuss your experience and fit.' },
        step3: { title: 'Join the Team', desc: 'Get your offer and start your journey with us!' },
        browse: 'Browse All Positions',
        contact: 'Contact HR Team'
      }
    },
    blogPage: {
      hero: {
        title: 'ShopHub Blog',
        subtitle: 'Discover insights, tips, and stories from the world of e-commerce. Stay informed with the latest trends and expert advice.',
        subscribe: 'Subscribe to Blog',
        viewCategories: 'View All Categories'
      },
      categories: {
        all: 'All Posts',
        shoppingTips: 'Shopping Tips',
        productReviews: 'Product Reviews',
        industryInsights: 'Industry Insights',
        companyCulture: 'Company Culture',
        sustainability: 'Sustainability',
        mobileTips: 'Mobile Tips',
        giftGuides: 'Gift Guides'
      },
      featured: {
        title: 'The Future of E-commerce: Trends Shaping 2024',
        category: 'Industry Insights',
        excerpt: 'Discover the emerging trends that are revolutionizing online shopping and how ShopHub is leading the charge in creating the next generation of e-commerce experiences.',
        date: 'December 20, 2023'
      },
      posts: {
        post1: { title: '10 Essential Tips for Holiday Shopping Success', category: 'Shopping Tips', excerpt: 'Make your holiday shopping stress-free with these expert tips for finding the best deals and perfect gifts.', date: 'December 15, 2023' },
        post2: { title: 'Sustainable Shopping: How to Make Eco-Friendly Choices', category: 'Sustainability', excerpt: 'Learn how to shop responsibly and reduce your environmental impact while still getting the products you love.', date: 'December 10, 2023' },
        post3: { title: 'Product Review: Top 5 Tech Gadgets of 2023', category: 'Product Reviews', excerpt: "Our comprehensive review of the year's most innovative tech gadgets that are worth your investment.", date: 'December 5, 2023' },
        post4: { title: 'Behind the Scenes: ShopHub\'s Customer Service Excellence', category: 'Company Culture', excerpt: 'Take a peek behind the curtain to see how our customer service team delivers exceptional support.', date: 'November 30, 2023' },
        post5: { title: 'Mobile Shopping: Optimizing Your Experience', category: 'Mobile Tips', excerpt: 'Maximize your mobile shopping experience with these tips and tricks for shopping on the go.', date: 'November 25, 2023' },
        post6: { title: 'Gift Guide: Perfect Presents for Every Budget', category: 'Gift Guides', excerpt: 'Find the perfect gift for everyone on your list, no matter what your budget looks like.', date: 'November 20, 2023' }
      },
      common: {
        readTime: '{{minutes}} min read',
        views: '{{count}}K',
        likes: '{{count}}',
        share: 'Share',
        readMore: 'Read More',
        loadMore: 'Load More Articles',
        featured: 'Featured Article'
      },
      newsletter: {
        title: 'Never Miss an Update',
        subtitle: 'Subscribe to our newsletter and get the latest articles, tips, and insights delivered directly to your inbox.',
        placeholder: 'Enter your email address',
        subscribe: 'Subscribe',
        note: 'Join 10,000+ subscribers. No spam, unsubscribe anytime.'
      }
    },
    pressPage: {
      hero: {
        title: 'Press & Media',
        subtitle: "Stay updated with ShopHub's latest news, announcements, and media resources. Your go-to source for company updates and press materials.",
        download: 'Download Media Kit',
        contact: 'Contact Press Team'
      },
      stats: {
        title: 'ShopHub by the Numbers',
        users: 'Active Users',
        products: 'Products',
        uptime: 'Uptime',
        countries: 'Countries'
      },
      releases: {
        title: 'Latest Press Releases',
        subtitle: 'Stay informed with our latest company news, product launches, and business updates.',
        readFull: 'Read Full Release',
        items: {
          q4growth: { title: 'ShopHub Announces Record-Breaking Q4 Sales Growth', category: 'Financial News', date: 'December 15, 2023', excerpt: 'ShopHub reports 45% year-over-year growth in Q4, driven by innovative features and expanded product catalog.' },
          sustainable: { title: 'ShopHub Partners with Leading Sustainable Brands', category: 'Partnerships', date: 'November 28, 2023', excerpt: 'New eco-friendly initiative brings 500+ sustainable products to our platform, supporting environmental responsibility.' },
          award: { title: 'ShopHub Wins E-commerce Innovation Award 2023', category: 'Awards', date: 'October 20, 2023', excerpt: 'Recognition for outstanding customer experience and technological advancement in online retail.' },
          expansion: { title: 'ShopHub Expands to 5 New International Markets', category: 'Expansion', date: 'September 12, 2023', excerpt: 'Global expansion brings ShopHub to customers in Europe and Asia, with localized shopping experiences.' }
        }
      },
      mediaKit: {
        title: 'Media Kit',
        subtitle: 'Download our complete media kit with logos, brand guidelines, and high-resolution assets.',
        download: 'Download',
        items: {
          logos: { title: 'Company Logos', desc: 'High-resolution logos in various formats' },
          brand: { title: 'Brand Guidelines', desc: 'Complete brand identity and usage guidelines' },
          images: { title: 'Product Images', desc: 'Professional product photography and screenshots' },
          team: { title: 'Executive Photos', desc: 'Professional headshots of leadership team' }
        }
      },
      awards: {
        title: 'Awards & Recognition',
        subtitle: "We're honored to be recognized by industry leaders for our innovation and excellence.",
        items: {
          ecommerce: { title: 'Best E-commerce Platform 2023', org: 'Digital Commerce Awards', year: '2023' },
          cx: { title: 'Innovation in Customer Experience', org: 'Retail Tech Excellence', year: '2023' },
          sustainable: { title: 'Sustainable Business Leader', org: 'Green Commerce Initiative', year: '2022' }
        }
      },
      contact: {
        title: 'Press Inquiries',
        subtitle: "For media inquiries, interview requests, or additional information, please contact our press team. We're here to help with your story.",
        pressContact: 'Press Contact',
        mediaRel: 'Media Relations',
        cta: 'Contact Press Team'
      }
    },
    newArrivalsPage: {
      title: 'New Arrivals',
      subtitle: 'Check out the latest additions to our collection.'
    },
    salesPage: {
      title: "Today's Deals",
      subtitle: 'Huge Savings on Top Brands!',
      offerText: 'Up to 40% OFF Selected Items'
    },
    vendor: {
        dashboard: 'Vendor Dashboard',
        shop: 'Shop',
        viewLiveShop: 'View Live Shop',
        addNewProduct: 'Add New Product',
        walletBalance: 'Wallet Balance',
        withdrawFunds: 'Withdraw Funds',
        processing: 'Processing...',
        totalEarnings: 'Total Earnings',
        myProducts: 'My Products',
        totalOrders: 'Total Orders',
        myListedProducts: 'My Listed Products',
        viewAllManaged: 'View All / Manage',
        product: 'Product',
        price: 'Price',
        stock: 'Stock',
        status: 'Status',
        actions: 'Actions',
        edit: 'Edit',
        delete: 'Delete',
        view: 'View',
        inStock: 'In Stock',
        outOfStock: 'Out of Stock',
        recentOrders: 'Recent Orders',
        unknownUser: 'Unknown User',
        order: 'Order',
        noProductsFound: 'No products found. Start selling by adding a product!',
        noOrdersYet: 'No orders yet.',
        applicationPending: {
            title: 'Application Under Review',
            message: 'Thank you for registering as a vendor. Your application is currently pending approval from our administrators. You will receive an email notification once your shop has been approved.',
            contactSupport: 'For questions, please contact'
        },
        applicationRejected: {
            title: 'Application Rejected',
            message: 'We regret to inform you that your vendor application has been rejected. This may be due to incomplete information or not meeting our seller strict criteria.',
            contactSupport: 'Please contact'
        },
        deleteModal: {
            title: 'Delete Product',
            message: 'Are you sure you want to delete this product? This action cannot be undone.',
            confirm: 'Delete',
            cancel: 'Cancel'
        },
        payoutSuccess: 'Payout requested successfully!',
        payoutError: 'Failed to request payout',
        deleteSuccess: 'Product deleted successfully',
        deleteError: 'Failed to delete product',
        loadError: 'Failed to load dashboard data'
    }
  },
  es: {
    common: {
      searchPlaceholder: 'Buscar productos...',
      search: 'Buscar',
      login: 'Iniciar Sesión',
      register: 'Registrarse',
      logout: 'Cerrar Sesión',
      profile: 'Perfil',
      myOrders: 'Mis Pedidos',
      myReviews: 'Mis Reseñas',
      wishlist: 'Lista de Deseos',
      cart: 'Carrito',
      help: 'Ayuda',
      trackOrder: 'Rastrear Pedido',
      adminDashboard: 'Panel de Administración',
      categories: 'Categorías',
      freeShipping: 'Envío gratis en pedidos superiores a',
      todaysDeals: 'Ofertas del Día',
      newArrivals: 'Nuevos Productos'
    },
    categories: {
      Electronics: 'Electrónica',
      Clothing: 'Ropa',
      Books: 'Libros',
      'Home & Garden': 'Hogar y Jardín',
      Sports: 'Deportes',
      Beauty: 'Belleza',
      Health: 'Salud',
      Toys: 'Juguetes',
      Automotive: 'Automotriz'
    },
    home: {
      welcomeTitle: 'Bienvenido a ShopHub',
      welcomeSubtitle: 'Tu destino único para todas tus compras. Descubre millones de productos a precios inmejorables.',
      shopNow: 'Comprar Ahora',
      shopCategory: 'Comprar por Categoría',
      exploreCategories: "Explora nuestra amplia gama de categorías para encontrar exactamente lo que buscas.",
      featuredProducts: 'Productos Destacados',
      discoverFeatured: 'Descubre nuestra selección de productos en tendencia.',
      viewAllProducts: 'Ver Todos los Productos',
      stayUpdated: 'Mantente Actualizado',
      subscribeText: 'Suscríbete a nuestro boletín y obtén ofertas exclusivas, novedades y promociones especiales.',
      enterEmail: 'Introduce tu email',
      subscribe: 'Suscribirse',
      subscribing: 'Suscribiendo...',
      features: {
        freeShipping: 'Envío Gratis',
        securePayment: 'Pago Seguro',
        securePaymentDesc: 'Procesamiento de pagos 100% seguro',
        moneyBack: 'Devolución de Dinero',
        moneyBackDesc: 'Garantía de devolución de 30 días',
        support: 'Soporte 24/7',
        supportDesc: 'Soporte al cliente las 24 horas'
      }
    },
    product: {
      availability: 'Disponibilidad',
      inStock: 'en stock',
      outOfStock: 'Agotado',
      onlyLeft: 'Solo quedan {{count}} en stock',
      addToCart: 'Añadir al Carrito',
      buyNow: 'Comprar Ahora',
      deliveryOptions: 'Opciones de Entrega',
      standardDelivery: 'Entrega Estándar',
      codAvailable: 'Pago Contra Reembolso Disponible',
      returnWarranty: 'Devolución y Garantía',
      easyReturn: 'días de devolución fácil',
      warranty: 'garantía',
      warrantyNotAvailable: 'Garantía no disponible',
      description: 'Descripción del Producto',
      specifications: 'Especificaciones',
      whatsInBox: 'Contenido de la Caja',
      reviews: 'Reseñas',
      questions: 'Preguntas y Respuestas',
      writeReview: 'Escribir una Reseña',
      writeYourReview: 'Escribe tu Reseña',
      rating: 'Valoración',
      review: 'Reseña',
      addPhotos: 'Añadir Fotos',
      chooseFiles: 'Elegir Archivos',
      submitReview: 'Enviar Reseña',
      cancel: 'Cancelar',
      askQuestion: 'Hacer una Pregunta',
      submitQuestion: 'Enviar Pregunta',
      askPlaceholder: 'Haz tu pregunta sobre este producto...',
      noReviews: 'Aún no hay reseñas. ¡Sé el primero en opinar!',
      noSpecs: 'No hay especificaciones disponibles para este producto.',
      noBoxContent: 'Información de contenido no disponible.',
      answerQ: 'Responder esta pregunta',
      submitAnswer: 'Enviar Respuesta'
    },
    cart: {
      title: 'Carrito de Compras',
      emptyTitle: 'Tu carrito está vacío',
      emptySubtitle: "Parece que aún no has añadido artículos a tu carrito.",
      continueShopping: 'Continuar Comprando',
      clearCart: 'Vaciar Carrito',
      item: 'artículo',
      items: 'artículos',
      inStock: 'En Stock',
      outOfStock: 'Agotado',
      available: 'disponibles',
      remove: 'Eliminar',
      orderSummary: 'Resumen del Pedido',
      subtotal: 'Subtotal',
      deliveryFee: 'Gastos de envío',
      free: 'GRATIS',
      addMoreForFree: '¡Añade {{amount}} más para envío GRATIS!',
      total: 'Total',
      proceedToCheckout: 'Proceder al Pago',
      secureCheckout: 'Pago Seguro',
      weAccept: 'Aceptamos',
      cod: 'Pago Contra Reembolso',
      card: 'Pago con Tarjeta'
    },
    auth: {
      loginTitle: 'Inicia sesión en tu cuenta',
      registerTitle: 'Crear una cuenta',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      confirmPassword: 'Confirmar Contraseña',
      name: 'Nombre Completo',
      forgotPassword: '¿Olvidaste tu contraseña?',
      signIn: 'Iniciar Sesión',
      signUp: 'Registrarse',
      newCustomer: '¿Nuevo cliente?',
      registerHere: 'Regístrate aquí',
      alreadyAccount: '¿Ya tienes una cuenta?',
      loginHere: 'Inicia sesión aquí',
      orContinue: 'O continuar con',
      phone: 'Número de teléfono',
      loginSuccess: '¡Inicio de sesión exitoso!',
      registerSuccess: '¡Registro exitoso!',
      rememberMe: 'Recuérdame',
      google: 'Google',
      facebook: 'Facebook'
    },
    support: {
      myTickets: 'Mis Tickets',
      newTicket: 'Nuevo Ticket',
      noTickets: 'No se encontraron tickets',
      noTicketsDesc: 'Aún no has enviado ningún ticket de soporte.',
      createFirst: 'Crea tu primer ticket',
      backToTickets: 'Volver a Tickets',
      closeTicket: 'Cerrar Ticket',
      yourMessage: 'Tu Mensaje',
      adminResponse: 'Respuesta del Administrador',
      markedResolved: 'Este ticket ha sido marcado como resuelto.',
      ticketClosed: 'Ticket Cerrado',
      closeConfirm: '¿Estás seguro de que deseas cerrar este ticket?',
      closeSuccess: 'Ticket cerrado exitosamente',
      closeError: 'Error al cerrar el ticket',
      fetchError: 'Error al cargar tickets'
    },
    footer: {
      description: 'Tu destino único para todas tus compras. Productos de calidad a precios asequibles.',
      quickLinks: 'Enlaces Rápidos',
      customerService: 'Servicio al Cliente',
      newsletter: 'Boletín',
      subscribeText: 'Suscríbete para obtener ofertas especiales, regalos y actualizaciones.',
      about: 'Sobre Nosotros',
      contact: 'Contacto',
      careers: 'Carreras',
      blog: 'Blog',
      press: 'Prensa',
      help: 'Centro de Ayuda',
      track: 'Rastrear Pedido',
      returns: 'Devoluciones y Reembolsos',
      shipping: 'Envío',
      sizeGuide: 'Guía de Tallas',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio',
      cookies: 'Política de Cookies',
      rights: 'Todos los derechos reservados.'
    },
    about: {
      hero: {
        title: 'Bienvenido a ShopHub',
        subtitle: 'Tu destino principal para productos de calidad y experiencias de compra excepcionales.',
        ctaStart: 'Empezar a Comprar',
        ctaLearn: 'Saber Más'
      },
      stats: {
        customers: 'Clientes Felices',
        products: 'Productos Disponibles',
        uptime: 'Garantía de Tiempo de Actividad',
        support: 'Soporte al Cliente'
      },
      mission: {
        title: 'Nuestra Misión',
        description: 'En ShopHub, nuestra misión es revolucionar las compras en línea proporcionando una experiencia fluida, segura y agradable. Creemos que las compras deben ser convenientes, asequibles y accesibles para todos.'
      },
      features: {
        title: '¿Por qué elegir ShopHub?',
        subtitle: 'Estamos comprometidos a brindarte la mejor experiencia de compra en línea posible.',
        wideSelection: { title: 'Amplia Selección', desc: 'Miles de productos en múltiples categorías' },
        fastShipping: { title: 'Envío Rápido', desc: 'Entrega rápida y confiable a tu puerta' },
        support247: { title: 'Soporte 24/7', desc: 'Servicio al cliente las 24 horas' },
        securePayment: { title: 'Pagos Seguros', desc: 'Procesamiento de pagos seguro y encriptado' },
        qualityGuarantee: { title: 'Garantía de Calidad', desc: 'Cada producto es seleccionado cuidadosamente' },
        trustedPlatform: { title: 'Plataforma Confiable', desc: 'Basado en confianza y satisfacción del cliente' }
      },
      values: {
        title: 'Nuestros Valores',
        subtitle: 'Estos valores guían todo lo que hacemos.',
        quality: { title: 'Calidad Primero', desc: 'Curamos cuidadosamente nuestros productos.' },
        trust: { title: 'Confianza del Cliente', desc: 'Construyendo relaciones a largo plazo.' },
        innovation: { title: 'Innovación', desc: 'Mejorando constantemente nuestra plataforma.' }
      },
      contact: {
        title: 'Ponte en Contacto',
        subtitle: '¿Tienes preguntas? Nuestro equipo está aquí para ayudar.',
        call: 'Llámanos',
        email: 'Envíanos un Email',
        chat: 'Chat en Vivo',
        chatAvail: 'Disponible 24/7',
        cta: 'Contactar Soporte'
      }
    },
    contactPage: {
      hero: {
        title: 'Ponte en Contacto',
        subtitle: '¡Estamos aquí para ayudar! Envíanos un mensaje y responderemos lo antes posible.'
      },
      info: {
        title: 'Información de Contacto',
        address: 'Dirección',
        phone: 'Teléfono',
        email: 'Correo electrónico',
        hours: 'Horario Comercial',
        days: {
          monFri: 'Lun - Vie',
          satSun: 'Sáb - Dom'
        }
      },
      responseTimes: {
        title: 'Tiempos de Respuesta',
        general: 'Consultas Generales',
        support: 'Problemas de Soporte',
        order: 'Problemas de Pedido',
        urgent: 'Asuntos Urgentes'
      },
      form: {
        title: 'Envíanos un Mensaje',
        name: 'Nombre',
        namePlaceholder: 'Tu nombre completo',
        email: 'Correo electrónico',
        emailPlaceholder: 'tu.email@ejemplo.com',
        phone: 'Teléfono',
        phonePlaceholder: 'Tu número de teléfono',
        subject: 'Asunto',
        subjects: {
          general: 'Consulta General',
          support: 'Soporte al Cliente',
          order: 'Problema con Pedido',
          return: 'Devolución/Reembolso',
          feedback: 'Comentarios',
          other: 'Otro'
        },
        orderNumber: 'Número de Pedido',
        orderPlaceholder: 'Ingresa tu ID de pedido para soporte más rápido',
        orderHint: 'Incluir tu número de pedido nos ayuda a asistirte más rápido',
        message: 'Mensaje',
        messagePlaceholder: 'Por favor describe tu consulta en detalle.',
        send: 'Enviar Mensaje',
        sending: 'Enviando Mensaje...'
      },
      success: {
        title: '¡Mensaje Enviado Exitosamente!',
        message: 'Gracias por contactarnos. Hemos recibido tu mensaje y te responderemos pronto.',
        ticketId: 'Tu ID de ticket:',
        saveId: 'Guarda este ID para referencia.',
        sendAnother: 'Enviar Otro Mensaje'
      }
    },
    helpPage: {
      title: 'Centro de Ayuda',
      subtitle: '¿Cómo podemos ayudarte?',
      searchPlaceholder: 'Buscar ayuda...',
      categories: {
        orders: { title: 'Pedidos y Envíos', desc: 'Rastrear pedidos, info de envío y entregas' },
        returns: { title: 'Devoluciones', desc: 'Política de devoluciones y reembolsos' },
        account: { title: 'Cuenta y Pago', desc: 'Configuración de cuenta y métodos de pago' }
      },
      faq: {
        title: 'Preguntas Frecuentes',
        q1: { q: '¿Cómo hago un pedido?', a: 'Navega por los productos, añádelos al carrito y procede al pago.' },
        q2: { q: '¿Qué métodos de pago aceptan?', a: 'Aceptamos tarjetas de crédito, PayPal y Apple Pay.' },
        q3: { q: '¿Cuánto tarda el envío?', a: 'El envío estándar tarda 3-5 días hábiles. Envío gratis en pedidos mayores a $50.' },
        q4: { q: '¿Cómo rastreo mi pedido?', a: 'Recibirás un número de rastreo por email al enviar tu pedido.' },
        q5: { q: '¿Cuál es su política de devolución?', a: 'Ofrecemos devolución de 30 días para la mayoría de los artículos.' },
        q6: { q: '¿Cómo contacto a servicio al cliente?', a: 'Contáctanos por formulario, email o teléfono.' }
      },
      stillNeedHelp: {
        title: '¿Aún necesitas ayuda?',
        desc: 'Nuestro equipo de soporte está aquí 24/7',
        cta: 'Contactar Soporte'
      }
    },
    returnsPage: {
      hero: {
        title: 'Devoluciones Sin Complicaciones',
        subtitle: '¡Queremos que ames tu compra! Si no estás satisfecho, devuélvelo en 30 días.',
        badges: { thirtyDay: '30 Días de Devolución', freeShipping: 'Envío de Devolución Gratis*', fastRefunds: 'Reembolsos Rápidos' }
      },
      tabs: { policy: 'Política', process: 'Proceso', tracking: 'Rastrear', faq: 'FAQ' },
      policy: {
        canReturn: 'Qué puedes devolver',
        cannotReturn: 'Qué no puedes devolver',
        canReturnList: ['Artículos originales', 'Con etiquetas', 'Dentro de 30 días', 'Con recibo'],
        cannotReturnList: ['Personalizados', 'Descargas', 'Perecederos', 'Dañados por uso'],
        timeframes: { title: 'Plazos por Categoría', most: 'Mayoría', electronics: 'Electrónica', beauty: 'Salud y Belleza' }
      },
      process: {
        title: 'Cronología del Proceso',
        steps: {
          initiate: { title: 'Iniciar', desc: 'Comenzar solicitud' },
          pack: { title: 'Empacar', desc: 'Empacar seguro' },
          processing: { title: 'Procesando', desc: 'Inspeccionamos' },
          refund: { title: 'Reembolso', desc: 'Emitido a original' }
        },
        startReturn: 'Iniciar Devolución',
        startDesc: '¿Necesitas devolver algo?',
        viewOrders: 'Ver Mis Pedidos',
        needHelp: '¿Ayuda?',
        contactSupport: 'Contactar Soporte'
      },
      tracking: {
        title: 'Rastrear Devolución',
        desc: 'Ingresa tu número de rastreo.',
        placeholder: 'Número de rastreo',
        track: 'Rastrear',
        tips: 'Consejos de Rastreo',
        tipsList: ['Rastreo por email', 'Tarda 24-48h', 'Contacta soporte si se pierde']
      },
      faq: {
        title: 'Preguntas Frecuentes',
        q1: { q: '¿Cuánto tiempo tengo?', a: '30 días desde entrega.' },
        q2: { q: '¿Quién paga el envío?', a: 'Gratis si es defectuoso.' },
        q3: { q: '¿Tiempo de reembolso?', a: '3-5 días hábiles.' },
        q4: { q: '¿Sin empaque original?', a: 'Preferible original.' },
        q5: { q: '¿Qué no se devuelve?', a: 'Personalizado, digital.' },
        q6: { q: '¿Puedo cambiar?', a: '¡Sí! Procesado como nuevo pedido.' }
      },
      footer: {
        guarantee: 'Garantía 100% Satisfacción',
        desc: 'Respaldamos nuestros productos.',
        email: 'Email Soporte',
        phone: 'Teléfono',
        hours: 'Horario'
      }
    },
    shippingPage: {
      hero: {
        title: 'Información de Envío',
        subtitle: 'Envío rápido y confiable.',
        badges: { free: 'Envío Gratis >1000', tracking: 'Rastreo Incluido', packaging: 'Empaque Seguro' }
      },
      tabs: { domestic: 'Nacional', international: 'Internacional', calculator: 'Calculadora' },
      domestic: {
        heroTitle: 'Envío Rápido',
        options: {
          standard: { name: 'Estándar', time: '5-7 días' },
          express: { name: 'Exprés', time: '2-3 días' },
          overnight: { name: 'Día Siguiente', time: '1 día' }
        },
        coverage: 'Áreas de Cobertura',
        majorCities: 'Ciudades Principales',
        otherAreas: 'Otras Áreas',
        services: 'Servicios Especiales',
        fragile: 'Frágil',
        scheduled: 'Programado'
      },
      international: {
        title: 'Envío Internacional',
        subtitle: 'Enviamos a todo el mundo.',
        zones: { zone1: 'Zona 1', zone2: 'Zona 2', zone3: 'Zona 3' },
        info: 'Información Importante'
      },
      calculator: {
        title: 'Calculadora de Envío',
        subtitle: 'Calcula costos.',
        placeholder: 'Código Postal',
        calculate: 'Calcular',
        estimates: 'Estimados'
      },
      faq: {
        title: 'FAQ de Envío',
        q1: { q: '¿Envío gratis?', a: 'Pedidos > 1000.' },
        q2: { q: '¿Fines de semana?', a: 'Siguiente día hábil.' },
        q3: { q: '¿Cambiar dirección?', a: 'En 1 hora.' },
        q4: { q: '¿No en casa?', a: '3 intentos.' },
        q5: { q: '¿Apartados postales?', a: 'Solo estándar.' },
        q6: { q: '¿Precisión?', a: '95% preciso.' }
      },
      contact: {
        title: '¿Ayuda con Envío?',
        subtitle: 'Estamos listos para ayudar.',
        contact: 'Soporte',
        track: 'Rastrear Pedido'
      }
    },
    sizeGuidePage: {
      title: 'Guía de Tallas',
      subtitle: 'Encuentra tu ajuste perfecto.',
      categories: { clothing: 'Ropa', pants: 'Pantalones', shoes: 'Calzado' },
      table: {
        size: 'Talla', chest: 'Pecho', waist: 'Cintura', hips: 'Caderas', length: 'Largo',
        shoulder: 'Hombro', sleeve: 'Manga', inseam: 'Entrepierna', uk: 'UK', us: 'US', eu: 'EU'
      },
      measure: {
        title: 'Cómo Medir',
        body: 'Medidas Corporales',
        garment: 'Medidas de Prenda',
        foot: 'Medidas de Pie',
        chest: 'Pecho', waist: 'Cintura', hips: 'Caderas', length: 'Largo',
        shoulder: 'Hombro', sleeve: 'Manga', ftLength: 'Largo', width: 'Ancho'
      },
      tips: {
        title: 'Consejos',
        list: ['Si dudas, talla más grande.', 'Revisa variaciones.', 'Pide ayuda.', 'Cinta ajustada.', 'Contáctanos.']
      }
    },
    trackOrderPage: {
      title: 'Rastrear su Pedido',
      subtitle: 'Ingrese su número de seguimiento o detalles del pedido para obtener actualizaciones en tiempo real',
      search: {
        byTracking: 'Por Número de Seguimiento',
        byOrder: 'Por ID de Pedido',
        trackingLabel: 'Número de Seguimiento',
        orderLabel: 'ID de Pedido',
        emailLabel: 'Dirección de Correo Electrónico',
        trackingPlaceholder: 'Ingrese su número de seguimiento (ej., TRK123456789)',
        orderPlaceholder: 'Ingrese su ID de pedido (ej., 507f1f77bcf86cd799439011)',
        emailPlaceholder: 'Ingrese el correo electrónico utilizado para este pedido',
        button: 'Rastrear Pedido',
        loading: 'Rastreando...',
      },
      error: {
        emptyInput: 'Por favor ingrese un número de seguimiento o ID de pedido',
        emptyEmail: 'Por favor ingrese su dirección de correo electrónico',
      },
      summary: {
        title: 'Resumen del Pedido',
        details: 'Detalles del Pedido',
        orderId: 'ID de Pedido',
        date: 'Fecha de Pedido',
        amount: 'Importe Total',
        status: 'Estado',
        trackingNumber: 'Número de Seguimiento',
        shippingAddress: 'Dirección de Envío',
        items: 'Artículos Pedidos',
        quantity: 'Cantidad',
      },
      timeline: {
        title: 'Línea de Tiempo de Seguimiento',
        trackWith: 'Rastrear con',
        estimated: 'Estimado',
        viewOnCarrier: 'Ver en el sitio web del transportista',
      },
      help: {
        title: '¿Necesita ayuda con su pedido?',
        subtitle: 'Si tiene alguna pregunta o inquietud sobre su pedido, nuestro equipo de atención al cliente está aquí para ayudar.',
        contact: 'Contactar Soporte',
        center: 'Centro de Ayuda',
      }
    },
    careersPage: {
      hero: {
        title: 'Únase a Nuestro Equipo',
        subtitle: 'Ayúdanos a construir el futuro del comercio electrónico. Únase a un equipo de personas apasionadas que crean productos que millones de personas adoran.',
        viewPositions: 'Ver Posiciones Abiertas',
        learnCulture: 'Conocer la Cultura'
      },
      stats: {
        members: 'Miembros del Equipo',
        positions: 'Posiciones Abiertas',
        countries: 'Países',
        rating: 'Calificación Glassdoor'
      },
      values: {
        title: 'Nuestros Valores',
        subtitle: 'Estos valores fundamentales guían todo lo que hacemos y dan forma a nuestra cultura.',
        customer: { title: 'Obsesión por el Cliente', desc: 'Ponemos a nuestros clientes en el centro de todo lo que hacemos, creando productos que realmente resuelven sus problemas.' },
        innovation: { title: 'Innovación', desc: 'Adoptamos nuevas tecnologías y soluciones creativas para mantenernos a la vanguardia.' },
        collaboration: { title: 'Colaboración', desc: 'Creemos que el mejor trabajo ocurre cuando equipos diversos colaboran abierta y respetuosamente.' },
        excellence: { title: 'Excelencia', desc: 'Establecemos altos estándares y nos esforzamos continuamente por superar las expectativas en todo lo que hacemos.' }
      },
      benefits: {
        title: 'Por Qué Trabajar Con Nosotros',
        subtitle: 'Ofrecemos beneficios competitivos y una cultura que apoya tu crecimiento y bienestar.',
        health: { title: 'Salud y Bienestar', desc: 'Seguro integral de salud, dental y visión más programas de bienestar' },
        schedule: { title: 'Horario Flexible', desc: 'Equilibrio trabajo-vida con horarios flexibles y PTO ilimitado' },
        learning: { title: 'Aprendizaje y Crecimiento', desc: 'Presupuesto anual de aprendizaje de $2,000 y asistencia a conferencias' },
        remote: { title: 'Trabajo Remoto', desc: 'Trabaja desde cualquier lugar con reuniones trimestrales del equipo' },
        pay: { title: 'Pago Competitivo', desc: 'Compensación de primer nivel con equidad y bonos por desempeño' },
        innovation: { title: 'Tiempo de Innovación', desc: '20% del tiempo para proyectos personales e iniciativas de innovación' }
      },
      jobs: {
        title: 'Posiciones Abiertas',
        subtitle: 'Encuentra tu próxima oportunidad profesional y únete a nuestro equipo en crecimiento.',
        apply: 'Aplicar Ahora',
        learnMore: 'Saber Más',
        requirements: 'Requisitos Clave:',
        frontend: { title: 'Desarrollador Frontend Senior', dept: 'Ingeniería', desc: 'Únete a nuestro equipo frontend para construir la próxima generación de experiencias de comercio electrónico usando React y TypeScript.', reqs: ['5+ años experiencia en React', 'Dominio de TypeScript', 'Preferible experiencia en e-commerce'] },
        marketing: { title: 'Gerente de Marketing de Producto', dept: 'Marketing', desc: 'Impulsa la estrategia de marketing de productos e iniciativas de lanzamiento al mercado.', reqs: ['3+ años en marketing de producto', 'Experiencia en SaaS B2B', 'Mentalidad basada en datos'] },
        design: { title: 'Diseñador UX/UI', dept: 'Diseño', desc: 'Crea experiencias de usuario hermosas e intuitivas que deleiten a nuestros millones de usuarios.', reqs: ['Experiencia en Figma', 'Investigación de usuarios', 'Portafolio de diseño e-commerce'] },
        devops: { title: 'Ingeniero DevOps', dept: 'Ingeniería', desc: 'Escala nuestra infraestructura para soportar millones de transacciones y asegurar 99.9% de actividad.', reqs: ['Experiencia AWS/Azure', 'Dominio de Kubernetes', 'Experiencia en CI/CD'] },
        cs: { title: 'Gerente de Éxito del Cliente', dept: 'Éxito del Cliente', desc: 'Ayuda a nuestros clientes empresariales a tener éxito y hacer crecer su negocio usando nuestra plataforma.', reqs: ['2+ años éxito del cliente', 'Fuertes habilidades de comunicación', 'Habilidades de resolución de problemas'] },
        data: { title: 'Científico de Datos', dept: 'Analítica', desc: 'Usa aprendizaje automático y análisis para impulsar ideas y optimizar el rendimiento de nuestra plataforma.', reqs: ['Dominio de Python/R', 'Experiencia en ML/AI', 'Antecedentes en estadística'] }
      },
      testimonials: {
        title: 'Lo Que Dice Nuestro Equipo',
        subtitle: 'Escucha de los miembros de nuestro equipo qué hace que ShopHub sea un gran lugar para trabajar.',
        sarah: { role: 'Gerente de Producto Senior', quote: "Las oportunidades de crecimiento aquí son increíbles. En solo dos años, he liderado tres lanzamientos importantes." },
        marcus: { role: 'Desarrollador Full Stack', quote: "La cultura de ingeniería es sobresaliente. Usamos tecnología de punta y todos están siempre dispuestos a ayudar." },
        emily: { role: 'Líder de Diseño', quote: "Me encanta cómo nuestro proceso de diseño está centrado en el usuario. Hablamos regularmente con clientes e iteramos." }
      },
      process: {
        title: '¿Listo para Aplicar?',
        subtitle: "Únete a nosotros para construir el futuro del comercio electrónico. ¡Estamos ansiosos por conocerte!",
        step1: { title: 'Aplica en Línea', desc: "Envía tu solicitud y cuéntanos por qué estás emocionado de unirte a ShopHub." },
        step2: { title: 'Proceso de Entrevista', desc: 'Reúnete con nuestro equipo a través de una serie de entrevistas para discutir tu experiencia.' },
        step3: { title: 'Únete al Equipo', desc: '¡Recibe tu oferta y comienza tu viaje con nosotros!' },
        browse: 'Ver Todas las Posiciones',
        contact: 'Contactar Equipo de RRHH'
      }
    },
    blogPage: {
      hero: {
        title: 'Blog de ShopHub',
        subtitle: 'Descubre ideas, consejos e historias del mundo del comercio electrónico. Mantente informado con las últimas tendencias.',
        subscribe: 'Suscribirse al Blog',
        viewCategories: 'Ver Todas las Categorías'
      },
      categories: {
        all: 'Todos los Posts',
        shoppingTips: 'Consejos de Compra',
        productReviews: 'Reseñas de Productos',
        industryInsights: 'Perspectivas de la Industria',
        companyCulture: 'Cultura de la Empresa',
        sustainability: 'Sostenibilidad',
        mobileTips: 'Consejos Móviles',
        giftGuides: 'Guías de Regalos'
      },
      featured: {
        title: 'El Futuro del E-commerce: Tendencias de 2024',
        category: 'Perspectivas de la Industria',
        excerpt: 'Descubre las tendencias emergentes que están revolucionando las compras en línea y cómo ShopHub lidera el cambio.',
        date: '20 de Diciembre, 2023'
      },
      posts: {
        post1: { title: '10 Consejos Esenciales para Compras Navideñas', category: 'Consejos de Compra', excerpt: 'Haz que tus compras navideñas sean libres de estrés con estos consejos expertos para encontrar las mejores ofertas.', date: '15 de Diciembre, 2023' },
        post2: { title: 'Compras Sostenibles: Elecciones Ecológicas', category: 'Sostenibilidad', excerpt: 'Aprende a comprar de manera responsable y reducir tu impacto ambiental mientras obtienes los productos que amas.', date: '10 de Diciembre, 2023' },
        post3: { title: 'Reseña de Producto: Top 5 Gadgets de 2023', category: 'Reseñas de Productos', excerpt: "Nuestra revisión exhaustiva de los gadgets tecnológicos más innovadores del año que valen la pena.", date: '5 de Diciembre, 2023' },
        post4: { title: 'Detrás de Escena: Excelencia en Servicio al Cliente', category: 'Cultura de la Empresa', excerpt: 'Echa un vistazo detrás de la cortina para ver cómo nuestro equipo de servicio al cliente ofrece un soporte excepcional.', date: '30 de Noviembre, 2023' },
        post5: { title: 'Compras Móviles: Optimizando tu Experiencia', category: 'Consejos Móviles', excerpt: 'Maximiza tu experiencia de compra móvil con estos consejos y trucos para comprar sobre la marcha.', date: '25 de Noviembre, 2023' },
        post6: { title: 'Guía de Regalos: Regalos Perfectos para Cada Presupuesto', category: 'Guías de Regalos', excerpt: 'Encuentra el regalo perfecto para todos en tu lista, sin importar cuál sea tu presupuesto.', date: '20 de Noviembre, 2023' }
      },
      common: {
        readTime: '{{minutes}} min de lectura',
        views: '{{count}}K',
        likes: '{{count}}',
        share: 'Compartir',
        readMore: 'Leer Más',
        loadMore: 'Cargar Más Artículos',
        featured: 'Artículo Destacado'
      },
      newsletter: {
        title: 'Nunca te Pierdas una Actualización',
        subtitle: 'Suscríbete a nuestro boletín y recibe los últimos artículos, consejos e ideas directamente en tu bandeja de entrada.',
        placeholder: 'Ingresa tu correo electrónico',
        subscribe: 'Suscribirse',
        note: 'Únete a más de 10,000 suscriptores. Sin spam, cancela cuando quieras.'
      }
    },
    pressPage: {
      hero: {
        title: 'Prensa y Medios',
        subtitle: "Mantente actualizado con las últimas noticias de ShopHub, anuncios y recursos para medios.",
        download: 'Descargar Kit de Prensa',
        contact: 'Contactar Equipo de Prensa'
      },
      stats: {
        title: 'ShopHub en Números',
        users: 'Usuarios Activos',
        products: 'Productos',
        uptime: 'Tiempo de Actividad',
        countries: 'Países'
      },
      releases: {
        title: 'Últimos Comunicados de Prensa',
        subtitle: 'Mantente informado con nuestras últimas noticias, lanzamientos de productos y actualizaciones comerciales.',
        readFull: 'Leer Comunicado Completo',
        items: {
          q4growth: { title: 'ShopHub Anuncia Crecimiento Récord en Ventas Q4', category: 'Noticias Financieras', date: '15 de Diciembre, 2023', excerpt: 'ShopHub reporta un crecimiento del 45% año tras año en el Q4, impulsado por funciones innovadoras.' },
          sustainable: { title: 'ShopHub se Asocia con Marcas Sostenibles Líderes', category: 'Asociaciones', date: '28 de Noviembre, 2023', excerpt: 'Nueva iniciativa ecológica trae más de 500 productos sostenibles a nuestra plataforma.' },
          award: { title: 'ShopHub Gana Premio a la Innovación en E-commerce 2023', category: 'Premios', date: '20 de Octubre, 2023', excerpt: 'Reconocimiento por experiencia del cliente excepcional y avance tecnológico.' },
          expansion: { title: 'ShopHub se Expande a 5 Nuevos Mercados Internacionales', category: 'Expansión', date: '12 de Septiembre, 2023', excerpt: 'La expansión global lleva a ShopHub a clientes en Europa y Asia.' }
        }
      },
      mediaKit: {
        title: 'Kit de Medios',
        subtitle: 'Descarga nuestro kit de medios completo con logotipos, guías de marca y activos de alta resolución.',
        download: 'Descargar',
        items: {
          logos: { title: 'Logotipos de la Empresa', desc: 'Logotipos de alta resolución en varios formatos' },
          brand: { title: 'Guías de Marca', desc: 'Identidad de marca completa y guías de uso' },
          images: { title: 'Imágenes de Producto', desc: 'Fotografía profesional de productos y capturas de pantalla' },
          team: { title: 'Fotos Ejecutivas', desc: 'Fotos profesionales del equipo de liderazgo' }
        }
      },
      awards: {
        title: 'Premios y Reconocimientos',
        subtitle: "Nos sentimos honrados de ser reconocidos por líderes de la industria por nuestra innovación y excelencia.",
        items: {
          ecommerce: { title: 'Mejor Plataforma de E-commerce 2023', org: 'Digital Commerce Awards', year: '2023' },
          cx: { title: 'Innovación en Experiencia del Cliente', org: 'Retail Tech Excellence', year: '2023' },
          sustainable: { title: 'Líder en Negocios Sostenibles', org: 'Green Commerce Initiative', year: '2022' }
        }
      },
      contact: {
        title: 'Consultas de Prensa',
        subtitle: "Para consultas de medios, solicitudes de entrevistas o información adicional, contacte a nuestro equipo de prensa.",
        pressContact: 'Contacto de Prensa',
        mediaRel: 'Relaciones con Medios',
        cta: 'Contactar Equipo de Prensa'
      }
    },
    newArrivalsPage: {
      title: 'Nuevos Productos',
      subtitle: 'Echa un vistazo a las últimas incorporaciones a nuestra colección.'
    },
    salesPage: {
      title: 'Ofertas del Día',
      subtitle: '¡Grandes Ahorros en las Mejores Marcas!',
      offerText: 'Hasta 40% de descuento en artículos seleccionados'
    }
  },
  fr: {
    common: {
      searchPlaceholder: 'Rechercher des produits...',
      search: 'Rechercher',
      login: 'Connexion',
      register: "S'inscrire",
      logout: 'Déconnexion',
      profile: 'Profil',
      myOrders: 'Mes Commandes',
      myReviews: 'Mes Avis',
      wishlist: 'Liste de Souhaits',
      cart: 'Panier',
      help: 'Aide',
      trackOrder: 'Suivre ma Commande',
      adminDashboard: 'Tableau de Bord Admin',
      categories: 'Catégories',
      freeShipping: 'Livraison gratuite pour les commandes de plus de',
      todaysDeals: 'Offres du Jour',
      newArrivals: 'Nouveautés'
    },
    categories: {
      Electronics: 'Électronique',
      Clothing: 'Vêtements',
      Books: 'Livres',
      'Home & Garden': 'Maison et Jardin',
      Sports: 'Sports',
      Beauty: 'Beauté',
      Health: 'Santé',
      Toys: 'Jouets',
      Automotive: 'Automobile'
    },
    home: {
      welcomeTitle: 'Bienvenue sur ShopHub',
      welcomeSubtitle: 'Votre destination unique pour tous vos besoins. Découvrez des millions de produits à des prix imbattables.',
      shopNow: 'Acheter Maintenant',
      shopCategory: 'Acheter par Catégorie',
      exploreCategories: "Explorez notre large gamme de catégories pour trouver exactement ce que vous cherchez.",
      featuredProducts: 'Produits Vedettes',
      discoverFeatured: 'Découvrez notre sélection de produits tendance.',
      viewAllProducts: 'Voir Tous les Produits',
      stayUpdated: 'Restez Informé',
      subscribeText: 'Abonnez-vous à notre newsletter pour des offres exclusives et nouveautés.',
      enterEmail: 'Entrez votre email',
      subscribe: "S'abonner",
      subscribing: 'En cours...',
      features: {
        freeShipping: 'Livraison Gratuite',
        securePayment: 'Paiement Sécurisé',
        securePaymentDesc: 'Traitement des paiements 100% sécurisé',
        moneyBack: 'Remboursement',
        moneyBackDesc: 'Garantie satisfait ou remboursé de 30 jours',
        support: 'Support 24/7',
        supportDesc: 'Service client disponible 24h/24'
      }
    },
    product: {
      availability: 'Disponibilité',
      inStock: 'en stock',
      outOfStock: 'Rupture de stock',
      onlyLeft: 'Plus que {{count}} en stock',
      addToCart: 'Ajouter au Panier',
      buyNow: 'Acheter Maintenant',
      deliveryOptions: 'Options de Livraison',
      standardDelivery: 'Livraison Standard',
      codAvailable: 'Paiement à la Livraison Disponible',
      returnWarranty: 'Retour & Garantie',
      easyReturn: 'jours de retour facile',
      warranty: 'garantie',
      warrantyNotAvailable: 'Garantie non disponible',
      description: 'Description du Produit',
      specifications: 'Spécifications',
      whatsInBox: 'Dans la Boîte',
      reviews: 'Avis',
      questions: 'Questions & Réponses',
      writeReview: 'Écrire un Avis',
      writeYourReview: 'Votre Avis',
      rating: 'Note',
      review: 'Avis',
      addPhotos: 'Ajouter Photos',
      chooseFiles: 'Choisir Fichiers',
      submitReview: 'Envoyer Avis',
      cancel: 'Annuler',
      askQuestion: 'Poser une Question',
      submitQuestion: 'Envoyer Question',
      askPlaceholder: 'Posez votre question sur ce produit...',
      noReviews: 'Pas encore d\'avis. Soyez le premier !',
      noSpecs: 'Pas de spécifications disponibles.',
      noBoxContent: 'Contenu non disponible.',
      answerQ: 'Répondre à cette question',
      submitAnswer: 'Envoyer Réponse'
    },
    cart: {
      title: 'Panier',
      emptyTitle: 'Votre panier est vide',
      emptySubtitle: "Il semble que vous n'ayez encore rien ajouté à votre panier.",
      continueShopping: 'Continuer mes achats',
      clearCart: 'Vider le panier',
      item: 'article',
      items: 'articles',
      inStock: 'En Stock',
      outOfStock: 'Rupture de Stock',
      available: 'disponible',
      remove: 'Supprimer',
      orderSummary: 'Résumé de la Commande',
      subtotal: 'Sous-total',
      deliveryFee: 'Frais de livraison',
      free: 'GRATUIT',
      addMoreForFree: 'Ajoutez {{amount}} pour la livraison GRATUITE !',
      total: 'Total',
      proceedToCheckout: 'Passer à la caisse',
      secureCheckout: 'Paiement sécurisé',
      weAccept: 'Nous acceptons',
      cod: 'Paiement à la livraison',
      card: 'Paiement par carte'
    },
    auth: {
      loginTitle: 'Connectez-vous à votre compte',
      registerTitle: 'Créer un compte',
      email: 'Adresse Email',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      name: 'Nom Complet',
      forgotPassword: 'Mot de passe oublié ?',
      signIn: 'Se Connecter',
      signUp: "S'inscrire",
      newCustomer: 'Nouveau client ?',
      registerHere: "Inscrivez-vous ici",
      alreadyAccount: 'Déjà un compte ?',
      loginHere: 'Connectez-vous ici',
      orContinue: 'Ou continuer avec',
      phone: 'Numéro de téléphone',
      loginSuccess: 'Connexion réussie !',
      registerSuccess: 'Inscription réussie !',
      rememberMe: 'Se souvenir de moi',
      google: 'Google',
      facebook: 'Facebook'
    },
    footer: {
      description: 'Votre destination unique pour tous vos besoins. Des produits de qualité à des prix abordables.',
      quickLinks: 'Liens Rapides',
      customerService: 'Service Client',
      newsletter: 'Newsletter',
      subscribeText: 'Abonnez-vous pour recevoir des offres spéciales, des cadeaux et des mises à jour.',
      about: 'À Propos',
      contact: 'Contact',
      careers: 'Carrières',
      blog: 'Blog',
      press: 'Presse',
      help: 'Centre d\'Aide',
      track: 'Suivre ma Commande',
      returns: 'Retours et Remboursements',
      shipping: 'Livraison',
      sizeGuide: 'Guide des Tailles',
      privacy: 'Politique de Confidentialité',
      terms: 'Conditions d\'Utilisation',
      cookies: 'Politique de Cookies',
      rights: 'Tous droits réservés.'
    },
    about: {
      hero: {
        title: 'Bienvenue sur ShopHub',
        subtitle: 'Votre destination privilégiée pour des produits de qualité et des expériences d\'achat exceptionnelles.',
        ctaStart: 'Commencer',
        ctaLearn: 'En savoir plus'
      },
      stats: {
        customers: 'Clients Satisfaits',
        products: 'Produits Disponibles',
        uptime: 'Garantie de Disponibilité',
        support: 'Service Client'
      },
      mission: {
        title: 'Notre Mission',
        description: 'Chez ShopHub, notre mission est de révolutionner le shopping en ligne en offrant une expérience fluide, sécurisée et agréable.'
      },
      features: {
        title: 'Pourquoi choisir ShopHub ?',
        subtitle: 'Nous nous engageons à vous offrir la meilleure expérience d\'achat.',
        wideSelection: { title: 'Large Sélection', desc: 'Des milliers de produits dans plusieurs catégories' },
        fastShipping: { title: 'Livraison Rapide', desc: 'Livraison rapide et fiable' },
        support247: { title: 'Support 24/7', desc: 'Service client disponible 24h/24' },
        securePayment: { title: 'Paiements Sécurisés', desc: 'Traitement des paiements 100% sécurisé' },
        qualityGuarantee: { title: 'Garantie Qualité', desc: 'Chaque produit est soigneusement sélectionné' },
        trustedPlatform: { title: 'Plateforme de Confiance', desc: 'Bâti sur la confiance et la satisfaction' }
      },
      values: {
        title: 'Nos Valeurs',
        subtitle: 'Ces valeurs guident tout ce que nous faisons.',
        quality: { title: 'Qualité d\'abord', desc: 'Nous sélectionnons nos produits avec soin.' },
        trust: { title: 'Confiance Client', desc: 'Construire des relations durables.' },
        innovation: { title: 'Innovation', desc: 'Amélioration constante de notre plateforme.' }
      },
      contact: {
        title: 'Contactez-nous',
        subtitle: 'Des questions ? Notre équipe est là pour vous aider.',
        call: 'Appelez-nous',
        email: 'Email',
        chat: 'Chat en Direct',
        chatAvail: 'Disponible 24/7',
        cta: 'Contact Support'
      }
    },
    contactPage: {
      hero: {
        title: 'Contactez-nous',
        subtitle: 'Nous sommes là pour vous aider ! Envoyez-nous un message et nous répondrons dès que possible.'
      },
      info: {
        title: 'Informations de Contact',
        address: 'Adresse',
        phone: 'Téléphone',
        email: 'Email',
        hours: 'Heures d\'Ouverture',
        days: {
          monFri: 'Lun - Ven',
          satSun: 'Sam - Dim'
        }
      },
      responseTimes: {
        title: 'Temps de Réponse',
        general: 'Questions Générales',
        support: 'Support Technique',
        order: 'Problèmes de Commande',
        urgent: 'Urgences'
      },
      form: {
        title: 'Envoyez-nous un Message',
        name: 'Nom',
        namePlaceholder: 'Votre nom complet',
        email: 'Email',
        emailPlaceholder: 'votre.email@exemple.com',
        phone: 'Téléphone',
        phonePlaceholder: 'Votre numéro',
        subject: 'Sujet',
        subjects: {
          general: 'Question Générale',
          support: 'Support Client',
          order: 'Problème Commande',
          return: 'Retour/Remboursement',
          feedback: 'Retour d\'expérience',
          other: 'Autre'
        },
        orderNumber: 'Numéro de Commande',
        orderPlaceholder: 'Entrez votre ID de commande',
        orderHint: 'Inclure votre numéro de commande nous aide à vous répondre plus vite',
        message: 'Message',
        messagePlaceholder: 'Veuillez décrire votre demande en détail.',
        send: 'Envoyer Message',
        sending: 'Envoi en cours...'
      },
      success: {
        title: 'Message Envoyé !',
        message: 'Merci de nous avoir contactés. Nous vous répondrons bientôt.',
        ticketId: 'Votre ID de ticket :',
        saveId: 'Conservez cet ID pour référence.',
        sendAnother: 'Envoyer un autre message'
      }
    },
    helpPage: {
      title: 'Centre d\'Aide',
      subtitle: 'Comment pouvons-nous vous aider ?',
      searchPlaceholder: 'Rechercher de l\'aide...',
      categories: {
        orders: { title: 'Commandes & Livraison', desc: 'Suivi, infos livraison' },
        returns: { title: 'Retours & Remboursements', desc: 'Politique de retour et échanges' },
        account: { title: 'Compte & Paiement', desc: 'Paramètres du compte et facturation' }
      },
      faq: {
        title: 'Questions Fréquentes',
        q1: { q: 'Comment passer une commande ?', a: 'Naviguez, ajoutez au panier et passez à la caisse.' },
        q2: { q: 'Quels paiements acceptez-vous ?', a: 'Cartes bancaires, PayPal et Apple Pay.' },
        q3: { q: 'Quels sont les délais de livraison ?', a: 'Standard 3-5 jours. Gratuit dès 50$.' },
        q4: { q: 'Comment suivre ma commande ?', a: 'Vous recevrez un numéro de suivi par email.' },
        q5: { q: 'Quelle est la politique de retour ?', a: 'Retour sous 30 jours pour la plupart des articles.' },
        q6: { q: 'Comment contacter le service client ?', a: 'Par formulaire, email ou téléphone.' }
      },
      stillNeedHelp: {
        title: 'Besoin d\'aide ?',
        desc: 'Notre équipe est là 24/7',
        cta: 'Contacter le Support'
      }
    },
    returnsPage: {
      hero: {
        title: 'Retours Faciles',
        subtitle: 'Nous voulons que vous aimiez votre achat ! Sinon, retournez-le sous 30 jours.',
        badges: { thirtyDay: 'Retours 30 Jours', freeShipping: 'Retour Gratuit*', fastRefunds: 'Remboursement Rapide' }
      },
      tabs: { policy: 'Politique', process: 'Processus', tracking: 'Suivi', faq: 'FAQ' },
      policy: {
        canReturn: 'Articles acceptés',
        cannotReturn: 'Articles refusés',
        canReturnList: ['État d\'origine', 'Avec étiquettes', 'Sous 30 jours', 'Avec preuve'],
        cannotReturnList: ['Personnalisé', 'Numérique', 'Périssable', 'Abîmé'],
        timeframes: { title: 'Délais par Catégorie', most: 'Plupart', electronics: 'Électronique', beauty: 'Santé & Beauté' }
      },
      process: {
        title: 'Chronologie',
        steps: {
          initiate: { title: 'Initier', desc: 'Commencer en ligne' },
          pack: { title: 'Emballer', desc: 'Emballer soigneusement' },
          processing: { title: 'Traitement', desc: 'Inspection' },
          refund: { title: 'Remboursement', desc: 'Émis sur mode original' }
        },
        startReturn: 'Démarrer Retour',
        startDesc: 'Besoin de retourner ?',
        viewOrders: 'Mes Commandes',
        needHelp: 'Besoin d\'aide ?',
        contactSupport: 'Contacter Support'
      },
      tracking: {
        title: 'Suivre Retour',
        desc: 'Entrez le numéro.',
        placeholder: 'Numéro de suivi',
        track: 'Suivre',
        tips: 'Conseils',
        tipsList: ['Reçu par email', '24-48h pour apparaître', 'Contacter support si perdu']
      },
      faq: {
        title: 'Questions Fréquentes',
        q1: { q: 'Combien de temps ?', a: '30 jours.' },
        q2: { q: 'Frais de retour ?', a: 'Gratuit si défectueux.' },
        q3: { q: 'Délai remboursement ?', a: '3-5 jours ouvrés.' },
        q4: { q: 'Sans emballage ?', a: 'Préférence origine.' },
        q5: { q: 'Non retournable ?', a: 'Personnalisé, périssable.' },
        q6: { q: 'Échange possible ?', a: 'Oui !' }
      },
      footer: {
        guarantee: 'Satisfaction 100%',
        desc: 'Nous soutenons nos produits.',
        email: 'Email',
        phone: 'Téléphone',
        hours: 'Heures'
      }
    },
    shippingPage: {
      hero: {
        title: 'Infos Livraison',
        subtitle: 'Livraison rapide et fiable.',
        badges: { free: 'Gratuit >1000', tracking: 'Suivi Inclus', packaging: 'Emballage Sécurisé' }
      },
      tabs: { domestic: 'National', international: 'International', calculator: 'Calculateur' },
      domestic: {
        heroTitle: 'Livraison Rapide',
        options: {
          standard: { name: 'Standard', time: '5-7 jours' },
          express: { name: 'Express', time: '2-3 jours' },
          overnight: { name: 'Lendemain', time: '1 jour' }
        },
        coverage: 'Zones de Livraison',
        majorCities: 'Villes Principales',
        otherAreas: 'Autres Zones',
        services: 'Services Spéciaux',
        fragile: 'Fragile',
        scheduled: 'Programmé'
      },
      international: {
        title: 'Livraison Internationale',
        subtitle: 'Nous livrons dans le monde entier.',
        zones: { zone1: 'Zone 1', zone2: 'Zone 2', zone3: 'Zone 3' },
        info: 'Infos Importantes'
      },
      calculator: {
        title: 'Calculateur',
        subtitle: 'Estimer les coûts.',
        placeholder: 'Code Postal',
        calculate: 'Calculer',
        estimates: 'Estimations'
      },
      faq: {
        title: 'FAQ Livraison',
        q1: { q: 'Livraison gratuite ?', a: 'Commandes > 1000.' },
        q2: { q: 'Week-ends ?', a: 'Jour ouvré suivant.' },
        q3: { q: 'Changer adresse ?', a: 'Sous 1 heure.' },
        q4: { q: 'Absent ?', a: '3 tentatives.' },
        q5: { q: 'Boîtes postales ?', a: 'Standard uniquement.' },
        q6: { q: 'Précision ?', a: '95% précis.' }
      },
      contact: {
        title: 'Aide Livraison ?',
        subtitle: 'Nous sommes là.',
        contact: 'Support',
        track: 'Suivre Commande'
      }
    },
    sizeGuidePage: {
      title: 'Guide des Tailles',
      subtitle: 'Trouvez votre taille idéale.',
      categories: { clothing: 'Vêtements', pants: 'Pantalons', shoes: 'Chaussures' },
      table: {
        size: 'Taille', chest: 'Poitrine', waist: 'Taille', hips: 'Hanches', length: 'Longueur',
        shoulder: 'Épaule', sleeve: 'Manche', inseam: 'Entrejambe', uk: 'UK', us: 'US', eu: 'UE'
      },
      measure: {
        title: 'Comment Mesurer',
        body: 'Mensurations',
        garment: 'Mesures vêtement',
        foot: 'Mesures pied',
        chest: 'Poitrine', waist: 'Taille', hips: 'Hanches', length: 'Longueur',
        shoulder: 'Épaule', sleeve: 'Manche', ftLength: 'Longueur', width: 'Largeur'
      },
      tips: {
        title: 'Conseils',
        list: ['Entre deux tailles, prenez la plus grande.', 'Vérifiez les marques.', 'Faites-vous aider.', 'Mètre ruban ajusté.', 'Contactez-nous.']
      }
    },
    trackOrderPage: {
      title: 'Suivre Votre Commande',
      subtitle: 'Entrez votre numéro de suivi ou les détails de la commande pour obtenir des mises à jour en temps réel',
      search: {
        byTracking: 'Par Numéro de Suivi',
        byOrder: 'Par ID de Commande',
        trackingLabel: 'Numéro de Suivi',
        orderLabel: 'ID de Commande',
        emailLabel: 'Adresse E-mail',
        trackingPlaceholder: 'Entrez votre numéro de suivi (ex: TRK123456789)',
        orderPlaceholder: 'Entrez votre ID de commande (ex: 507f1f77bcf86cd799439011)',
        emailPlaceholder: 'Entrez l\'e-mail utilisé pour cette commande',
        button: 'Suivre la Commande',
        loading: 'Suivi en cours...',
      },
      error: {
        emptyInput: 'Veuillez entrer un numéro de suivi ou un ID de commande',
        emptyEmail: 'Veuillez entrer votre adresse e-mail',
      },
      summary: {
        title: 'Résumé de la Commande',
        details: 'Détails de la Commande',
        orderId: 'ID de Commande',
        date: 'Date de Commande',
        amount: 'Montant Total',
        status: 'Statut',
        trackingNumber: 'Numéro de Suivi',
        shippingAddress: 'Adresse de Livraison',
        items: 'Articles Commandés',
        quantity: 'Quantité',
      },
      timeline: {
        title: 'Chronologie de Suivi',
        trackWith: 'Suivre avec',
        estimated: 'Estimé',
        viewOnCarrier: 'Voir sur le site du transporteur',
      },
      help: {
        title: 'Besoin d\'aide avec votre commande ?',
        subtitle: 'Si vous avez des questions ou des préoccupations concernant votre commande, notre équipe de service client est là pour vous aider.',
        contact: 'Contacter le Support',
        center: 'Centre d\'Aide',
      }
    },
    careersPage: {
      hero: {
        title: 'Rejoignez Notre Équipe',
        subtitle: 'Aidez-nous à construire l\'avenir du commerce électronique. Rejoignez une équipe passionnée créant des produits aimés par des millions de personnes.',
        viewPositions: 'Voir les Postes Ouverts',
        learnCulture: 'Découvrir la Culture'
      },
      stats: {
        members: 'Membres de l\'Équipe',
        positions: 'Postes Ouverts',
        countries: 'Pays',
        rating: 'Note Glassdoor'
      },
      values: {
        title: 'Nos Valeurs',
        subtitle: 'Ces valeurs fondamentales guident tout ce que nous faisons et façonnent notre culture.',
        customer: { title: 'Obsession Client', desc: 'Nous mettons nos clients au cœur de tout ce que nous faisons.' },
        innovation: { title: 'Innovation', desc: 'Nous adoptons de nouvelles technologies et solutions créatives pour garder une longueur d\'avance.' },
        collaboration: { title: 'Collaboration', desc: 'Nous croyons que le meilleur travail se fait lorsque des équipes diverses collaborent.' },
        excellence: { title: 'Excellence', desc: 'Nous fixons des normes élevées et nous efforçons continuellement de dépasser les attentes.' }
      },
      benefits: {
        title: 'Pourquoi Travailler Avec Nous',
        subtitle: 'Nous offrons des avantages compétitifs et une culture qui soutient votre croissance et votre bien-être.',
        health: { title: 'Santé & Bien-être', desc: 'Assurance santé complète, dentaire et vision plus programmes de bien-être' },
        schedule: { title: 'Horaires Flexibles', desc: 'Équilibre travail-vie avec horaires flexibles et congés illimités' },
        learning: { title: 'Apprentissage', desc: 'Budget annuel d\'apprentissage de 2 000 $ et participation à des conférences' },
        remote: { title: 'Télétravail', desc: 'Travaillez de n\'importe où avec des rassemblements trimestriels' },
        pay: { title: 'Rémunération Compétitive', desc: 'Rémunération de haut niveau avec actions et primes de performance' },
        innovation: { title: 'Temps d\'Innovation', desc: '20% du temps pour des projets personnels et initiatives d\'innovation' }
      },
      jobs: {
        title: 'Postes Ouverts',
        subtitle: 'Trouvez votre prochaine opportunité de carrière et rejoignez notre équipe grandissante.',
        apply: 'Postuler Maintenant',
        learnMore: 'En Savoir Plus',
        requirements: 'Prérequis Clés :',
        frontend: { title: 'Développeur Frontend Senior', dept: 'Ingénierie', desc: 'Rejoignez notre équipe frontend pour construire la prochaine génération d\'expériences e-commerce.', reqs: ['5+ ans expérience React', 'Maîtrise TypeScript', 'Expérience e-commerce préférée'] },
        marketing: { title: 'Responsable Marketing Produit', dept: 'Marketing', desc: 'Pilotez la stratégie marketing produit et les initiatives de mise sur le marché.', reqs: ['3+ ans marketing produit', 'Expérience SaaS B2B', 'Esprit axé sur les données'] },
        design: { title: 'Designer UX/UI', dept: 'Design', desc: 'Créez des expériences utilisateur belles et intuitives qui ravissent nos millions d\'utilisateurs.', reqs: ['Expertise Figma', 'Expérience recherche utilisateur', 'Portfolio design e-commerce'] },
        devops: { title: 'Ingénieur DevOps', dept: 'Ingénierie', desc: 'Mettez à l\'échelle notre infrastructure pour soutenir des millions de transactions.', reqs: ['Expérience AWS/Azure', 'Maîtrise Kubernetes', 'Expertise CI/CD'] },
        cs: { title: 'Responsable Succès Client', dept: 'Succès Client', desc: 'Aidez nos clients entreprises à réussir et à développer leur activité.', reqs: ['2+ ans succès client', 'Forte communication', 'Capacités de résolution de problèmes'] },
        data: { title: 'Data Scientist', dept: 'Analytique', desc: 'Utilisez l\'apprentissage automatique et l\'analyse pour optimiser les performances.', reqs: ['Maîtrise Python/R', 'Expérience ML/IA', 'Formation statistique'] }
      },
      testimonials: {
        title: 'Ce Que Dit Notre Équipe',
        subtitle: 'Écoutez les membres de notre équipe sur ce qui fait de ShopHub un endroit formidable pour travailler.',
        sarah: { role: 'Chef de Produit Senior', quote: "Les opportunités de croissance ici sont incroyables. En deux ans, j'ai dirigé trois lancements majeurs." },
        marcus: { role: 'Développeur Full Stack', quote: "La culture d'ingénierie est exceptionnelle. Nous utilisons des technologies de pointe et tout le monde aide." },
        emily: { role: 'Lead Design', quote: "J'adore à quel point notre processus de conception est centré sur l'utilisateur. Nous parlons régulièrement aux clients." }
      },
      process: {
        title: 'Prêt à Postuler ?',
        subtitle: "Rejoignez-nous pour construire l'avenir du commerce électronique. Nous avons hâte de vous rencontrer !",
        step1: { title: 'Postuler en Ligne', desc: "Envoyez votre candidature et dites-nous pourquoi vous êtes enthousiaste à l'idée de rejoindre ShopHub." },
        step2: { title: 'Processus d\'Entretien', desc: 'Rencontrez notre équipe lors d\'une série d\'entretiens pour discuter de votre expérience.' },
        step3: { title: 'Rejoindre l\'Équipe', desc: 'Recevez votre offre et commencez votre aventure avec nous !' },
        browse: 'Voir Tous les Postes',
        contact: 'Contacter RH'
      }
    },
    blogPage: {
      hero: {
        title: 'Blog ShopHub',
        subtitle: 'Découvrez des idées, des conseils et des histoires du monde du commerce électronique. Restez informé des dernières tendances.',
        subscribe: 'S\'abonner au Blog',
        viewCategories: 'Voir Toutes les Catégories'
      },
      categories: {
        all: 'Tous les Articles',
        shoppingTips: 'Conseils Shopping',
        productReviews: 'Avis Produits',
        industryInsights: 'Tendances Industrie',
        companyCulture: 'Culture d\'Entreprise',
        sustainability: 'Durabilité',
        mobileTips: 'Conseils Mobiles',
        giftGuides: 'Guides Cadeaux'
      },
      featured: {
        title: 'L\'Avenir du E-commerce : Tendances 2024',
        category: 'Tendances Industrie',
        excerpt: 'Découvrez les tendances émergentes qui révolutionnent les achats en ligne et comment ShopHub mène la charge.',
        date: '20 Décembre 2023'
      },
      posts: {
        post1: { title: '10 Conseils Essentiels pour le Shopping des Fêtes', category: 'Conseils Shopping', excerpt: 'Faites vos achats de fin d\'année sans stress avec ces conseils d\'experts pour trouver les meilleures offres.', date: '15 Décembre 2023' },
        post2: { title: 'Shopping Durable : Choix Écologiques', category: 'Durabilité', excerpt: 'Apprenez à acheter de manière responsable et à réduire votre impact environnemental tout en obtenant ce que vous aimez.', date: '10 Décembre 2023' },
        post3: { title: 'Avis Produit : Top 5 Gadgets Tech 2023', category: 'Avis Produits', excerpt: "Notre avis complet sur les gadgets technologiques les plus innovants de l'année qui valent l'investissement.", date: '5 Décembre 2023' },
        post4: { title: 'Coulisses : L\'Excellence du Service Client ShopHub', category: 'Culture d\'Entreprise', excerpt: 'Jetez un coup d\'œil en coulisses pour voir comment notre équipe de service client offre un support exceptionnel.', date: '30 Novembre 2023' },
        post5: { title: 'Shopping Mobile : Optimisez Votre Expérience', category: 'Conseils Mobiles', excerpt: 'Maximisez votre expérience d\'achat mobile avec ces trucs et astuces pour acheter en déplacement.', date: '25 Novembre 2023' },
        post6: { title: 'Guide Cadeaux : Cadeaux Parfaits pour Tous Budgets', category: 'Guides Cadeaux', excerpt: 'Trouvez le cadeau parfait pour tout le monde sur votre liste, quel que soit votre budget.', date: '20 Novembre 2023' }
      },
      common: {
        readTime: '{{minutes}} min de lecture',
        views: '{{count}}K',
        likes: '{{count}}',
        share: 'Partager',
        readMore: 'Lire Plus',
        loadMore: 'Charger Plus d\'Articles',
        featured: 'Article Vedette'
      },
      newsletter: {
        title: 'Ne Manquez Jamais une Mise à Jour',
        subtitle: 'Abonnez-vous à notre newsletter et recevez les derniers articles, conseils et idées directement dans votre boîte de réception.',
        placeholder: 'Entrez votre adresse email',
        subscribe: 'S\'abonner',
        note: 'Rejoignez 10 000+ abonnés. Pas de spam, désabonnement à tout moment.'
      }
    },
    pressPage: {
      hero: {
        title: 'Presse et Médias',
        subtitle: "Restez à jour avec les dernières nouvelles, annonces et ressources médiatiques de ShopHub.",
        download: 'Télécharger le Kit Média',
        contact: 'Contacter l\'Équipe Presse'
      },
      stats: {
        title: 'ShopHub en Chiffres',
        users: 'Utilisateurs Actifs',
        products: 'Produits',
        uptime: 'Disponibilité',
        countries: 'Pays'
      },
      releases: {
        title: 'Derniers Communiqués de Presse',
        subtitle: 'Restez informé de nos dernières actualités, lancements de produits et mises à jour commerciales.',
        readFull: 'Lire le Communiqué',
        items: {
          q4growth: { title: 'ShopHub Annonce une Croissance Record des Ventes au T4', category: 'Infos Financières', date: '15 Décembre 2023', excerpt: 'ShopHub rapporte une croissance de 45% sur un an au T4.' },
          sustainable: { title: 'ShopHub s\'Associe à des Marques Durables Leaders', category: 'Partenariats', date: '28 Novembre 2023', excerpt: 'Nouvelle initiative écologique apportant 500+ produits durables.' },
          award: { title: 'ShopHub Remporte le Prix de l\'Innovation E-commerce 2023', category: 'Prix', date: '20 Octobre 2023', excerpt: 'Reconnaissance pour une expérience client exceptionnelle.' },
          expansion: { title: 'ShopHub s\'étend sur 5 Nouveaux Marchés Internationaux', category: 'Expansion', date: '12 Septembre 2023', excerpt: 'L\'expansion mondiale apporte ShopHub aux clients en Europe et en Asie.' }
        }
      },
      mediaKit: {
        title: 'Kit Média',
        subtitle: 'Téléchargez notre kit média complet avec logos, directives de marque et ressources haute résolution.',
        download: 'Télécharger',
        items: {
          logos: { title: 'Logos d\'Entreprise', desc: 'Logos haute résolution en divers formats' },
          brand: { title: 'Directives de Marque', desc: 'Identité de marque complète et directives d\'utilisation' },
          images: { title: 'Images Produits', desc: 'Photographie professionnelle de produits et captures d\'écran' },
          team: { title: 'Photos Exécutives', desc: 'Portraits professionnels de l\'équipe de direction' }
        }
      },
      awards: {
        title: 'Prix et Reconnaissance',
        subtitle: "Nous sommes honorés d'être reconnus par les leaders de l'industrie pour notre innovation et notre excellence.",
        items: {
          ecommerce: { title: 'Meilleure Plateforme E-commerce 2023', org: 'Digital Commerce Awards', year: '2023' },
          cx: { title: 'Innovation en Expérience Client', org: 'Retail Tech Excellence', year: '2023' },
          sustainable: { title: 'Leader du Commerce Durable', org: 'Green Commerce Initiative', year: '2022' }
        }
      },
      contact: {
        title: 'Demandes Presse',
        subtitle: "Pour les demandes médias, interviews ou informations supplémentaires, contactez notre équipe presse.",
        pressContact: 'Contact Presse',
        mediaRel: 'Relations Médias',
        cta: 'Contacter Équipe Presse'
      }
    },
    newArrivalsPage: {
      title: 'Nouveautés',
      subtitle: 'Découvrez les derniers ajouts à notre collection.'
    },
    salesPage: {
      title: 'Offres du Jour',
      subtitle: 'Économies massives sur les grandes marques !',
      offerText: "Jusqu'à 40% de réduction sur une sélection d'articles"
    }
  },
  de: {
    common: {
      searchPlaceholder: 'Produkte suchen...',
      search: 'Suchen',
      login: 'Anmelden',
      register: 'Registrieren',
      logout: 'Abmelden',
      profile: 'Profil',
      myOrders: 'Meine Bestellungen',
      myReviews: 'Meine Bewertungen',
      wishlist: 'Wunschliste',
      cart: 'Warenkorb',
      help: 'Hilfe',
      trackOrder: 'Bestellung verfolgen',
      adminDashboard: 'Admin-Dashboard',
      categories: 'Kategorien',
      freeShipping: 'Kostenloser Versand ab',
      todaysDeals: 'Tagesangebote',
      newArrivals: 'Neuheiten'
    },
    categories: {
      Electronics: 'Elektronik',
      Clothing: 'Kleidung',
      Books: 'Bücher',
      'Home & Garden': 'Haus & Garten',
      Sports: 'Sport',
      Beauty: 'Schönheit',
      Health: 'Gesundheit',
      Toys: 'Spielzeug',
      Automotive: 'Automobil'
    },
    home: {
      welcomeTitle: 'Willkommen bei ShopHub',
      welcomeSubtitle: 'Ihr One-Stop-Ziel für alle Ihre Einkaufsbedürfnisse. Entdecken Sie Millionen von Produkten zu unschlagbaren Preisen.',
      shopNow: 'Jetzt Einkaufen',
      shopCategory: 'Nach Kategorie Einkaufen',
      exploreCategories: "Entdecken Sie unsere große Auswahl an Kategorien.",
      featuredProducts: 'Hervorgehobene Produkte',
      discoverFeatured: 'Entdecken Sie unsere Auswahl an Trendprodukten.',
      viewAllProducts: 'Alle Produkte Ansehen',
      stayUpdated: 'Bleiben Sie informiert',
      subscribeText: 'Abonnieren Sie unseren Newsletter für exklusive Angebote.',
      enterEmail: 'E-Mail eingeben',
      subscribe: 'Abonnieren',
      subscribing: 'Abonnieren...',
      features: {
        freeShipping: 'Kostenloser Versand',
        securePayment: 'Sichere Bezahlung',
        securePaymentDesc: '100% sichere Zahlungsabwicklung',
        moneyBack: 'Geld zurück',
        moneyBackDesc: '30 Tage Geld-zurück-Garantie',
        support: '24/7 Support',
        supportDesc: 'Rund um die Uhr Kundensupport'
      }
    },
    product: {
      availability: 'Verfügbarkeit',
      inStock: 'auf Lager',
      outOfStock: 'Ausverkauft',
      onlyLeft: 'Nur noch {{count}} auf Lager',
      addToCart: 'In den Warenkorb',
      buyNow: 'Jetzt Kaufen',
      deliveryOptions: 'Lieferoptionen',
      standardDelivery: 'Standardlieferung',
      codAvailable: 'Barzahlung bei Lieferung möglich',
      returnWarranty: 'Rückgabe & Garantie',
      easyReturn: 'Tage einfache Rückgabe',
      warranty: 'Garantie',
      warrantyNotAvailable: 'Garantie nicht verfügbar',
      description: 'Produktbeschreibung',
      specifications: 'Spezifikationen',
      whatsInBox: 'Lieferumfang',
      reviews: 'Bewertungen',
      questions: 'Fragen & Antworten',
      writeReview: 'Bewertung schreiben',
      writeYourReview: 'Ihre Bewertung',
      rating: 'Bewertung',
      review: 'Rezension',
      addPhotos: 'Fotos hinzufügen',
      chooseFiles: 'Dateien auswählen',
      submitReview: 'Bewertung absenden',
      cancel: 'Abbrechen',
      askQuestion: 'Frage stellen',
      submitQuestion: 'Frage absenden',
      askPlaceholder: 'Stellen Sie Ihre Frage zu diesem Produkt...',
      noReviews: 'Noch keine Bewertungen. Seien Sie der Erste!',
      noSpecs: 'Keine Spezifikationen verfügbar.',
      noBoxContent: 'Keine Informationen zum Lieferumfang.',
      answerQ: 'Diese Frage beantworten',
      submitAnswer: 'Antwort absenden'
    },
    cart: {
      title: 'Warenkorb',
      emptyTitle: 'Ihr Warenkorb ist leer',
      emptySubtitle: "Sie haben noch keine Artikel in Ihren Warenkorb gelegt.",
      continueShopping: 'Weiter einkaufen',
      clearCart: 'Warenkorb leeren',
      item: 'Artikel',
      items: 'Artikel',
      inStock: 'Auf Lager',
      outOfStock: 'Nicht auf Lager',
      available: 'verfügbar',
      remove: 'Entfernen',
      orderSummary: 'Bestellübersicht',
      subtotal: 'Zwischensumme',
      deliveryFee: 'Versandkosten',
      free: 'GRATIS',
      addMoreForFree: 'Fügen Sie {{amount}} für KOSTENLOSEN Versand hinzu!',
      total: 'Gesamt',
      proceedToCheckout: 'Zur Kasse',
      secureCheckout: 'Sichere Bezahlung',
      weAccept: 'Wir akzeptieren',
      cod: 'Barzahlung bei Lieferung',
      card: 'Kartenzahlung'
    },
    auth: {
      loginTitle: 'In Ihr Konto einloggen',
      registerTitle: 'Konto erstellen',
      email: 'E-Mail-Adresse',
      password: 'Passwort',
      confirmPassword: 'Passwort bestätigen',
      name: 'Vollständiger Name',
      forgotPassword: 'Passwort vergessen?',
      signIn: 'Anmelden',
      signUp: 'Registrieren',
      newCustomer: 'Neuer Kunde?',
      registerHere: 'Hier registrieren',
      alreadyAccount: 'Haben Sie bereits ein Konto?',
      loginHere: 'Hier anmelden',
      orContinue: 'Oder weiter mit',
      phone: 'Telefonnummer',
      loginSuccess: 'Anmeldung erfolgreich!',
      registerSuccess: 'Registrierung erfolgreich!',
      rememberMe: 'Angemeldet bleiben',
      google: 'Google',
      facebook: 'Facebook'
    },
    footer: {
      description: 'Ihr One-Stop-Ziel für alle Ihre Einkaufsbedürfnisse. Qualitätsprodukte zu erschwinglichen Preisen.',
      quickLinks: 'Schnelllinks',
      customerService: 'Kundenservice',
      newsletter: 'Newsletter',
      subscribeText: 'Abonnieren Sie, um Sonderangebote, kostenlose Geschenke und Updates zu erhalten.',
      about: 'Über Uns',
      contact: 'Kontakt',
      careers: 'Karriere',
      blog: 'Blog',
      press: 'Presse',
      help: 'Hilfe-Center',
      track: 'Bestellung Verfolgen',
      returns: 'Rücksendungen & Rückerstattungen',
      shipping: 'Versandinfo',
      sizeGuide: 'Größentabelle',
      privacy: 'Datenschutz',
      terms: 'Nutzungsbedingungen',
      cookies: 'Cookie-Richtlinie',
      rights: 'Alle Rechte vorbehalten.'
    },
    about: {
      hero: {
        title: 'Willkommen bei ShopHub',
        subtitle: 'Ihr erstklassiges Ziel für Qualitätsprodukte und außergewöhnliche Einkaufserlebnisse.',
        ctaStart: 'Jetzt Einkaufen',
        ctaLearn: 'Mehr Erfahren'
      },
      stats: {
        customers: 'Zufriedene Kunden',
        products: 'Verfügbare Produkte',
        uptime: 'Verfügbarkeitsgarantie',
        support: 'Kundensupport'
      },
      mission: {
        title: 'Unsere Mission',
        description: 'Bei ShopHub ist es unsere Mission, das Online-Shopping zu revolutionieren, indem wir ein nahtloses, sicheres und angenehmes Erlebnis bieten.'
      },
      features: {
        title: 'Warum ShopHub wählen?',
        subtitle: 'Wir verpflichten uns, Ihnen das bestmögliche Einkaufserlebnis zu bieten.',
        wideSelection: { title: 'Große Auswahl', desc: 'Tausende von Produkten in vielen Kategorien' },
        fastShipping: { title: 'Schneller Versand', desc: 'Schnelle und zuverlässige Lieferung' },
        support247: { title: '24/7 Support', desc: 'Rund um die Uhr Kundenservice' },
        securePayment: { title: 'Sichere Zahlungen', desc: 'Sichere und verschlüsselte Zahlungsabwicklung' },
        qualityGuarantee: { title: 'Qualitätsgarantie', desc: 'Jedes Produkt wird sorgfältig ausgewählt' },
        trustedPlatform: { title: 'Vertrauenswürdig', desc: 'Basiert auf Vertrauen und Kundenzufriedenheit' }
      },
      values: {
        title: 'Unsere Werte',
        subtitle: 'Diese Werte leiten alles, was wir tun.',
        quality: { title: 'Qualität zuerst', desc: 'Wir kuratieren unsere Produkte sorgfältig.' },
        trust: { title: 'Kundenvertrauen', desc: 'Aufbau langfristiger Beziehungen.' },
        innovation: { title: 'Innovation', desc: 'Ständige Verbesserung unserer Plattform.' }
      },
      contact: {
        title: 'Kontaktieren Sie uns',
        subtitle: 'Haben Sie Fragen? Unser Team ist hier, um zu helfen.',
        call: 'Rufen Sie uns an',
        email: 'E-Mail',
        chat: 'Live-Chat',
        chatAvail: 'Verfügbar 24/7',
        cta: 'Support Kontaktieren'
      }
    },
    contactPage: {
      hero: {
        title: 'Kontaktieren Sie uns',
        subtitle: 'Wir sind hier, um zu helfen! Senden Sie uns eine Nachricht.'
      },
      info: {
        title: 'Kontaktinformationen',
        address: 'Adresse',
        phone: 'Telefon',
        email: 'E-Mail',
        hours: 'Öffnungszeiten',
        days: {
          monFri: 'Mo - Fr',
          satSun: 'Sa - So'
        }
      },
      responseTimes: {
        title: 'Antwortzeiten',
        general: 'Allgemeine Anfragen',
        support: 'Support-Probleme',
        order: 'Bestellprobleme',
        urgent: 'Dringende Angelegenheiten'
      },
      form: {
        title: 'Nachricht Senden',
        name: 'Name',
        namePlaceholder: 'Ihr vollständiger Name',
        email: 'E-Mail',
        emailPlaceholder: 'ihre.email@beispiel.com',
        phone: 'Telefon',
        phonePlaceholder: 'Ihre Telefonnummer',
        subject: 'Betreff',
        subjects: {
          general: 'Allgemeine Anfrage',
          support: 'Kundensupport',
          order: 'Bestellproblem',
          return: 'Rückgabe/Erstattung',
          feedback: 'Feedback',
          other: 'Sonstiges'
        },
        orderNumber: 'Bestellnummer',
        orderPlaceholder: 'Bestell-ID eingeben',
        orderHint: 'Die Angabe Ihrer Bestellnummer hilft uns, Ihnen schneller zu helfen',
        message: 'Nachricht',
        messagePlaceholder: 'Bitte beschreiben Sie Ihr Anliegen im Detail.',
        send: 'Nachricht Senden',
        sending: 'Senden...'
      },
      success: {
        title: 'Nachricht Erfolgreich Gesendet!',
        message: 'Danke, dass Sie uns kontaktiert haben. Wir werden uns bald bei Ihnen melden.',
        ticketId: 'Ihre Ticket-ID:',
        saveId: 'Speichern Sie diese ID als Referenz.',
        sendAnother: 'Eine weitere Nachricht senden'
      }
    },
    helpPage: {
      title: 'Hilfe-Center',
      subtitle: 'Wie können wir Ihnen helfen?',
      searchPlaceholder: 'Nach Hilfe suchen...',
      categories: {
        orders: { title: 'Bestellungen & Versand', desc: 'Bestellungen verfolgen, Versandinfos' },
        returns: { title: 'Rücksendungen', desc: 'Rückgaberichtlinien und Rückerstattungen' },
        account: { title: 'Konto & Zahlung', desc: 'Kontoeinstellungen und Zahlungsmethoden' }
      },
      faq: {
        title: 'Häufig gestellte Fragen',
        q1: { q: 'Wie bestelle ich?', a: 'Produkte auswählen, in den Warenkorb legen und zur Kasse gehen.' },
        q2: { q: 'Welche Zahlungsarten akzeptieren Sie?', a: 'Kreditkarten, PayPal und Apple Pay.' },
        q3: { q: 'Wie lange dauert der Versand?', a: 'Standardversand 3-5 Werktage. Kostenlos ab 50$.' },
        q4: { q: 'Wie verfolge ich meine Bestellung?', a: 'Sie erhalten eine Tracking-Nummer per E-Mail.' },
        q5: { q: 'Wie ist die Rückgaberichtlinie?', a: '30 Tage Rückgaberecht für die meisten Artikel.' },
        q6: { q: 'Wie kontaktiere ich den Support?', a: 'Per Formular, E-Mail oder Telefon.' }
      },
      stillNeedHelp: {
        title: 'Noch Fragen?',
        desc: 'Unser Support-Team ist 24/7 für Sie da',
        cta: 'Support Kontaktieren'
      }
    },
    returnsPage: {
      hero: {
        title: 'Einfache Rückgabe',
        subtitle: 'Wenn Sie nicht zufrieden sind, senden Sie es innerhalb von 30 Tagen zurück.',
        badges: { thirtyDay: '30 Tage Rückgabe', freeShipping: 'Kostenloser Rückversand*', fastRefunds: 'Schnelle Rückerstattung' }
      },
      tabs: { policy: 'Richtlinie', process: 'Prozess', tracking: 'Verfolgen', faq: 'FAQ' },
      policy: {
        canReturn: 'Was Sie zurückgeben können',
        cannotReturn: 'Was nicht',
        canReturnList: ['Originalzustand', 'Mit Etiketten', 'Binnen 30 Tagen', 'Mit Beleg'],
        cannotReturnList: ['Personalisiert', 'Digital', 'Verderblich', 'Beschädigt'],
        timeframes: { title: 'Fristen', most: 'Meiste', electronics: 'Elektronik', beauty: 'Gesundheit' }
      },
      process: {
        title: 'Ablauf',
        steps: {
          initiate: { title: 'Starten', desc: 'Online beginnen' },
          pack: { title: 'Verpacken', desc: 'Sicher verpacken' },
          processing: { title: 'Bearbeitung', desc: 'Prüfung' },
          refund: { title: 'Rückerstattung', desc: 'Gutschrift' }
        },
        startReturn: 'Rückgabe Starten',
        startDesc: 'Rückgabe nötig?',
        viewOrders: 'Meine Bestellungen',
        needHelp: 'Hilfe nötig?',
        contactSupport: 'Kontakt'
      },
      tracking: {
        title: 'Rücksendung Verfolgen',
        desc: 'Nummer eingeben.',
        placeholder: 'Tracking-Nummer',
        track: 'Verfolgen',
        tips: 'Tipps',
        tipsList: ['Per E-Mail', 'Dauer 24-48h', 'Support kontaktieren']
      },
      faq: {
        title: 'Häufige Fragen',
        q1: { q: 'Wie lange?', a: '30 Tage.' },
        q2: { q: 'Versandkosten?', a: 'Kostenlos bei Defekt.' },
        q3: { q: 'Dauer?', a: '3-5 Werktage.' },
        q4: { q: 'Ohne Verpackung?', a: 'Original bevorzugt.' },
        q5: { q: 'Nicht erstattungsfähig?', a: 'Personalisiert.' },
        q6: { q: 'Umtausch?', a: 'Ja, möglich.' }
      },
      footer: {
        guarantee: '100% Zufriedenheit',
        desc: 'Wir stehen hinter unseren Produkten.',
        email: 'E-Mail',
        phone: 'Telefon',
        hours: 'Zeiten'
      }
    },
    shippingPage: {
      hero: {
        title: 'Versandinformationen',
        subtitle: 'Schneller Versand.',
        badges: { free: 'Kostenlos >1000', tracking: 'Tracking Inkl.', packaging: 'Sicher verpackt' }
      },
      tabs: { domestic: 'Inland', international: 'International', calculator: 'Rechner' },
      domestic: {
        heroTitle: 'Schneller Versand',
        options: {
          standard: { name: 'Standard', time: '5-7 Tage' },
          express: { name: 'Express', time: '2-3 Tage' },
          overnight: { name: 'Nächster Tag', time: '1 Tag' }
        },
        coverage: 'Liefergebiete',
        majorCities: 'Großstädte',
        otherAreas: 'Andere Gebiete',
        services: 'Spezialservices',
        fragile: 'Zerbrechlich',
        scheduled: 'Terminiert'
      },
      international: {
        title: 'Internationaler Versand',
        subtitle: 'Weltweiter Versand.',
        zones: { zone1: 'Zone 1', zone2: 'Zone 2', zone3: 'Zone 3' },
        info: 'Wichtige Infos'
      },
      calculator: {
        title: 'Versandrechner',
        subtitle: 'Kosten berechnen.',
        placeholder: 'PLZ',
        calculate: 'Berechnen',
        estimates: 'Schätzungen'
      },
      faq: {
        title: 'Versand FAQ',
        q1: { q: 'Kostenlos?', a: '> 1000.' },
        q2: { q: 'Wochenende?', a: 'Nächster Werktag.' },
        q3: { q: 'Adresse ändern?', a: 'Binnen 1 Stunde.' },
        q4: { q: 'Nicht zuhause?', a: '3 Versuche.' },
        q5: { q: 'Postfach?', a: 'Nur Standard.' },
        q6: { q: 'Genauigkeit?', a: '95%.' }
      },
      contact: {
        title: 'Versandhilfe?',
        subtitle: 'Wir helfen.',
        contact: 'Kontakt',
        track: 'Verfolgen'
      }
    },
    sizeGuidePage: {
      title: 'Größentabelle',
      subtitle: 'Finden Sie Ihre Passform.',
      categories: { clothing: 'Kleidung', pants: 'Hosen', shoes: 'Schuhe' },
      table: {
        size: 'Größe', chest: 'Brust', waist: 'Taille', hips: 'Hüfte', length: 'Länge',
        shoulder: 'Schulter', sleeve: 'Ärmel', inseam: 'Schrittlänge', uk: 'UK', us: 'US', eu: 'EU'
      },
      measure: {
        title: 'Messen',
        body: 'Körpermaße',
        garment: 'Kleidungsmaße',
        foot: 'Fußmaße',
        chest: 'Brust', waist: 'Taille', hips: 'Hüfte', length: 'Länge',
        shoulder: 'Schulter', sleeve: 'Ärmel', ftLength: 'Länge', width: 'Breite'
      },
      tips: {
        title: 'Tipps',
        list: ['Im Zweifel größer.', 'Marken prüfen.', 'Hilfe holen.', 'Band eng anliegend.', 'Kontaktieren Sie uns.']
      }
    },
    trackOrderPage: {
      title: 'Bestellung Verfolgen',
      subtitle: 'Geben Sie Ihre Sendungsnummer oder Bestelldetails ein, um Echtzeit-Updates zu erhalten',
      search: {
        byTracking: 'Nach Sendungsnummer',
        byOrder: 'Nach Bestell-ID',
        trackingLabel: 'Sendungsnummer',
        orderLabel: 'Bestell-ID',
        emailLabel: 'E-Mail-Adresse',
        trackingPlaceholder: 'Geben Sie Ihre Sendungsnummer ein (z.B. TRK123456789)',
        orderPlaceholder: 'Geben Sie Ihre Bestell-ID ein (z.B. 507f1f77bcf86cd799439011)',
        emailPlaceholder: 'Geben Sie die für diese Bestellung verwendete E-Mail ein',
        button: 'Bestellung Verfolgen',
        loading: 'Verfolgung...',
      },
      error: {
        emptyInput: 'Bitte geben Sie eine Sendungsnummer oder Bestell-ID ein',
        emptyEmail: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
      },
      summary: {
        title: 'Bestellübersicht',
        details: 'Bestelldetails',
        orderId: 'Bestell-ID',
        date: 'Bestelldatum',
        amount: 'Gesamtbetrag',
        status: 'Status',
        trackingNumber: 'Sendungsnummer',
        shippingAddress: 'Lieferadresse',
        items: 'Bestellte Artikel',
        quantity: 'Menge',
      },
      timeline: {
        title: 'Verfolgungszeitleiste',
        trackWith: 'Verfolgen mit',
        estimated: 'Geschätzt',
        viewOnCarrier: 'Auf der Website des Frachtführers ansehen',
      },
      help: {
        title: 'Benötigen Sie Hilfe bei Ihrer Bestellung?',
        subtitle: 'Wenn Sie Fragen oder Bedenken zu Ihrer Bestellung haben, ist unser Kundensupport-Team hier, um zu helfen.',
        contact: 'Support Kontaktieren',
        center: 'Hilfecenter',
      }
    },
    careersPage: {
      hero: {
        title: 'Kommen Sie zu uns',
        subtitle: 'Helfen Sie uns, die Zukunft des E-Commerce zu gestalten. Werden Sie Teil eines leidenschaftlichen Teams.',
        viewPositions: 'Offene Stellen Ansehen',
        learnCulture: 'Über Kultur Lernen'
      },
      stats: {
        members: 'Teammitglieder',
        positions: 'Offene Stellen',
        countries: 'Länder',
        rating: 'Glassdoor Bewertung'
      },
      values: {
        title: 'Unsere Werte',
        subtitle: 'Diese Grundwerte leiten alles, was wir tun, und prägen unsere Kultur.',
        customer: { title: 'Kundenbesessenheit', desc: 'Wir stellen unsere Kunden in den Mittelpunkt von allem, was wir tun.' },
        innovation: { title: 'Innovation', desc: 'Wir setzen auf neue Technologien und kreative Lösungen.' },
        collaboration: { title: 'Zusammenarbeit', desc: 'Wir glauben, dass die beste Arbeit entsteht, wenn Teams offen zusammenarbeiten.' },
        excellence: { title: 'Exzellenz', desc: 'Wir setzen hohe Standards und streben ständig danach, Erwartungen zu übertreffen.' }
      },
      benefits: {
        title: 'Warum bei uns arbeiten',
        subtitle: 'Wir bieten wettbewerbsfähige Vorteile und eine Kultur, die Ihr Wachstum unterstützt.',
        health: { title: 'Gesundheit & Wellness', desc: 'Umfassende Kranken-, Zahn- und Augenversicherung sowie Wellnessprogramme' },
        schedule: { title: 'Flexibler Zeitplan', desc: 'Work-Life-Balance mit flexiblen Arbeitszeiten und unbegrenztem Urlaub' },
        learning: { title: 'Lernen & Wachstum', desc: '2.000 $ jährliches Lernbudget und Konferenzteilnahme' },
        remote: { title: 'Remote-First', desc: 'Arbeiten Sie von überall mit vierteljährlichen Teamtreffen' },
        pay: { title: 'Wettbewerbsfähige Bezahlung', desc: 'Erstklassige Vergütung mit Aktienoptionen und Leistungsprämien' },
        innovation: { title: 'Innovationszeit', desc: '20% Zeit für persönliche Projekte und Innovationsinitiativen' }
      },
      jobs: {
        title: 'Offene Stellen',
        subtitle: 'Finden Sie Ihre nächste Karrieremöglichkeit und werden Sie Teil unseres wachsenden Teams.',
        apply: 'Jetzt Bewerben',
        learnMore: 'Mehr Erfahren',
        requirements: 'Wichtige Anforderungen:',
        frontend: { title: 'Senior Frontend Entwickler', dept: 'Entwicklung', desc: 'Bauen Sie die nächste Generation von E-Commerce-Erlebnissen mit React und TypeScript.', reqs: ['5+ Jahre React-Erfahrung', 'TypeScript-Kenntnisse', 'E-Commerce-Hintergrund bevorzugt'] },
        marketing: { title: 'Produktmarketing-Manager', dept: 'Marketing', desc: 'Treiben Sie Produktmarketingstrategien und Markteinführungsinitiativen voran.', reqs: ['3+ Jahre Produktmarketing', 'B2B SaaS Erfahrung', 'Datenorientierte Denkweise'] },
        design: { title: 'UX/UI Designer', dept: 'Design', desc: 'Erstellen Sie schöne, intuitive Benutzererlebnisse, die unsere Millionen von Nutzern begeistern.', reqs: ['Figma Expertise', 'Benutzerforschung', 'E-Commerce Design Portfolio'] },
        devops: { title: 'DevOps Ingenieur', dept: 'Entwicklung', desc: 'Skalieren Sie unsere Infrastruktur, um Millionen von Transaktionen zu unterstützen.', reqs: ['AWS/Azure Erfahrung', 'Kubernetes Kenntnisse', 'CI/CD Expertise'] },
        cs: { title: 'Customer Success Manager', dept: 'Kundenerfolg', desc: 'Helfen Sie unseren Unternehmenskunden, erfolgreich zu sein und ihr Geschäft auszubauen.', reqs: ['2+ Jahre Customer Success', 'Starke Kommunikation', 'Problemlösungsfähigkeiten'] },
        data: { title: 'Data Scientist', dept: 'Analytik', desc: 'Nutzen Sie maschinelles Lernen und Analytik, um Erkenntnisse zu gewinnen.', reqs: ['Python/R Kenntnisse', 'ML/KI Erfahrung', 'Statistik-Hintergrund'] }
      },
      testimonials: {
        title: 'Was unser Team sagt',
        subtitle: 'Hören Sie von unseren Teammitgliedern, was ShopHub zu einem großartigen Arbeitsplatz macht.',
        sarah: { role: 'Senior Produktmanager', quote: "Die Wachstumschancen hier sind unglaublich. In nur zwei Jahren habe ich drei große Produkteinführungen geleitet." },
        marcus: { role: 'Full Stack Entwickler', quote: "Die Ingenieurskultur ist hervorragend. Wir verwenden modernste Technologien und jeder hilft gerne." },
        emily: { role: 'Design Lead', quote: "Ich liebe es, wie nutzerzentriert unser Designprozess ist. Wir sprechen regelmäßig mit Kunden." }
      },
      process: {
        title: 'Bereit zur Bewerbung?',
        subtitle: "Bauen Sie mit uns die Zukunft des E-Commerce. Wir können es kaum erwarten, Sie kennenzulernen!",
        step1: { title: 'Online Bewerben', desc: "Senden Sie Ihre Bewerbung und erzählen Sie uns, warum Sie zu ShopHub kommen möchten." },
        step2: { title: 'Interviewprozess', desc: 'Treffen Sie unser Team in einer Reihe von Interviews.' },
        step3: { title: 'Team Beitreten', desc: 'Erhalten Sie Ihr Angebot und beginnen Sie Ihre Reise mit uns!' },
        browse: 'Alle Stellen Ansehen',
        contact: 'HR Team Kontaktieren'
      }
    },
    blogPage: {
      hero: {
        title: 'ShopHub Blog',
        subtitle: 'Entdecken Sie Einblicke, Tipps und Geschichten aus der Welt des E-Commerce. Bleiben Sie informiert.',
        subscribe: 'Blog Abonnieren',
        viewCategories: 'Alle Kategorien Ansehen'
      },
      categories: {
        all: 'Alle Beiträge',
        shoppingTips: 'Einkaufstipps',
        productReviews: 'Produktbewertungen',
        industryInsights: 'Brancheneinblicke',
        companyCulture: 'Unternehmenskultur',
        sustainability: 'Nachhaltigkeit',
        mobileTips: 'Mobile Tipps',
        giftGuides: 'Geschenkführer'
      },
      featured: {
        title: 'Die Zukunft des E-Commerce: Trends 2024',
        category: 'Brancheneinblicke',
        excerpt: 'Entdecken Sie die aufkommenden Trends, die das Online-Shopping revolutionieren, und wie ShopHub führend ist.',
        date: '20. Dezember 2023'
      },
      posts: {
        post1: { title: '10 Wichtige Tipps für den Weihnachtseinkauf', category: 'Einkaufstipps', excerpt: 'Machen Sie Ihren Weihnachtseinkauf stressfrei mit diesen Expertentipps.', date: '15. Dezember 2023' },
        post2: { title: 'Nachhaltiges Einkaufen: Umweltfreundliche Wahl', category: 'Nachhaltigkeit', excerpt: 'Erfahren Sie, wie Sie verantwortungsbewusst einkaufen und Ihren ökologischen Fußabdruck reduzieren können.', date: '10. Dezember 2023' },
        post3: { title: 'Produktbewertung: Top 5 Tech-Gadgets 2023', category: 'Produktbewertungen', excerpt: "Unsere umfassende Bewertung der innovativsten Tech-Gadgets des Jahres.", date: '5. Dezember 2023' },
        post4: { title: 'Hinter den Kulissen: ShopHub Kundenservice', category: 'Unternehmenskultur', excerpt: 'Werfen Sie einen Blick hinter die Kulissen, um zu sehen, wie unser Team außergewöhnlichen Support bietet.', date: '30. November 2023' },
        post5: { title: 'Mobile Shopping: Optimierung Ihres Erlebnisses', category: 'Mobile Tipps', excerpt: 'Maximieren Sie Ihr mobiles Einkaufserlebnis mit diesen Tipps und Tricks.', date: '25. November 2023' },
        post6: { title: 'Geschenkführer: Perfekte Geschenke für jedes Budget', category: 'Geschenkführer', excerpt: 'Finden Sie das perfekte Geschenk für jeden auf Ihrer Liste, unabhängig vom Budget.', date: '20. November 2023' }
      },
      common: {
        readTime: '{{minutes}} Min. Lesezeit',
        views: '{{count}}K',
        likes: '{{count}}',
        share: 'Teilen',
        readMore: 'Weiterlesen',
        loadMore: 'Mehr Artikel Laden',
        featured: 'Vorgestellter Artikel'
      },
      newsletter: {
        title: 'Verpassen Sie kein Update',
        subtitle: 'Abonnieren Sie unseren Newsletter und erhalten Sie die neuesten Artikel direkt in Ihren Posteingang.',
        placeholder: 'Geben Sie Ihre E-Mail-Adresse ein',
        subscribe: 'Abonnieren',
        note: 'Schließen Sie sich über 10.000 Abonnenten an. Kein Spam, jederzeit abbestellbar.'
      }
    },
    pressPage: {
      hero: {
        title: 'Presse & Medien',
        subtitle: "Bleiben Sie auf dem Laufenden mit den neuesten Nachrichten, Ankündigungen und Medienressourcen von ShopHub.",
        download: 'Medienkit Herunterladen',
        contact: 'Presseteam Kontaktieren'
      },
      stats: {
        title: 'ShopHub in Zahlen',
        users: 'Aktive Nutzer',
        products: 'Produkte',
        uptime: 'Betriebszeit',
        countries: 'Länder'
      },
      releases: {
        title: 'Neueste Pressemitteilungen',
        subtitle: 'Bleiben Sie informiert über unsere neuesten Unternehmensnachrichten, Produkteinführungen und Updates.',
        readFull: 'Vollständige Mitteilung Lesen',
        items: {
          q4growth: { title: 'ShopHub verkündet rekordverdächtiges Umsatzwachstum im Q4', category: 'Finanznachrichten', date: '15. Dezember 2023', excerpt: 'ShopHub meldet 45% Wachstum im Jahresvergleich im Q4.' },
          sustainable: { title: 'ShopHub partnert mit führenden nachhaltigen Marken', category: 'Partnerschaften', date: '28. November 2023', excerpt: 'Neue umweltfreundliche Initiative bringt 500+ nachhaltige Produkte auf unsere Plattform.' },
          award: { title: 'ShopHub gewinnt E-Commerce-Innovationspreis 2023', category: 'Auszeichnungen', date: '20. Oktober 2023', excerpt: 'Anerkennung für herausragende Kundenerfahrung und technologischen Fortschritt.' },
          expansion: { title: 'ShopHub expandiert in 5 neue internationale Märkte', category: 'Expansion', date: '12. September 2023', excerpt: 'Globale Expansion bringt ShopHub zu Kunden in Europa und Asien.' }
        }
      },
      mediaKit: {
        title: 'Medienkit',
        subtitle: 'Laden Sie unser komplettes Medienkit mit Logos, Markenrichtlinien und hochauflösenden Assets herunter.',
        download: 'Herunterladen',
        items: {
          logos: { title: 'Unternehmenslogos', desc: 'Hochauflösende Logos in verschiedenen Formaten' },
          brand: { title: 'Markenrichtlinien', desc: 'Vollständige Markenidentität und Nutzungsrichtlinien' },
          images: { title: 'Produktbilder', desc: 'Professionelle Produktfotografie und Screenshots' },
          team: { title: 'Führungsfotos', desc: 'Professionelle Porträts des Führungsteams' }
        }
      },
      awards: {
        title: 'Auszeichnungen & Anerkennung',
        subtitle: "Wir fühlen uns geehrt, von Branchenführern für unsere Innovation und Exzellenz anerkannt zu werden.",
        items: {
          ecommerce: { title: 'Beste E-Commerce-Plattform 2023', org: 'Digital Commerce Awards', year: '2023' },
          cx: { title: 'Innovation im Kundenerlebnis', org: 'Retail Tech Excellence', year: '2023' },
          sustainable: { title: 'Nachhaltiger Unternehmensführer', org: 'Green Commerce Initiative', year: '2022' }
        }
      },
      contact: {
        title: 'Presseanfragen',
        subtitle: "Für Medienanfragen, Interviewanfragen oder zusätzliche Informationen kontaktieren Sie bitte unser Presseteam.",
        pressContact: 'Pressekontakt',
        mediaRel: 'Medienbeziehungen',
        cta: 'Presseteam Kontaktieren'
      }
    },
    newArrivalsPage: {
      title: 'Neuheiten',
      subtitle: 'Entdecken Sie die neuesten Ergänzungen unserer Kollektion.'
    },
    salesPage: {
      title: 'Angebote des Tages',
      subtitle: 'Riesige Einsparungen bei Top-Marken!',
      offerText: 'Bis zu 40% Rabatt auf ausgewählte Artikel'
    }
  }
};
